import gsap, { Elastic, TweenLite, TweenMax } from 'gsap';
import { ISkeletonData, Spine } from "pixi-spine";
import * as PIXI from 'pixi.js';
import { AwardOptionPosition, CelebrationType, ExpandingWildReelConfiguration, FreegamesEndAction, FreegamesSpinAction, FreegamesStartAction, ISimpleBonusAction, LineWin, PlusOneFeatureConfiguration, PlusOneFeatureResult, ScatterRandomAwardConfiguration, ScatterRandomAwardResult, SharedJackpotWin, SimpleSlotGameState, SimpleTriggerResult, SlotGameBet, SpinAndHoldStartAction } from "../../api";
import { AudioManager, Track } from "../../AudioManager";
import { ClientState } from "../../ClientState";
import { ISystemContext } from "../../Context/SystemContext";
import { ITimeout } from "../../Context/Timeout";
import { GameSession } from "../../GameSession";
import { BackendSettings } from "../../help/Help";
import { enableJackpotSharedMap, JackpotSharedShow } from "../../JackpotSharedShow";
import { AddMouseDownListener, Color, CreateElement, CreateSpineResources, Log, LogGroup, Point, Rect, Safe, Scale, SetStyles, Size, Timing } from "../../MyHelpers";
import { AtlasResource } from "../../ResourceManager/AtlasResource";
import { FontResource } from "../../ResourceManager/FontResource";
import { DecodedImageResource, ImageResource } from "../../ResourceManager/ImageResource";
import { JSONResource } from "../../ResourceManager/JSONResource";
import { Resourceful2 } from "../../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage, ResourceManager } from "../../ResourceManager/ResourceManager";
import { SpriteResource } from "../../ResourceManager/SpriteResource";
import { RobotPlay } from "../../RobotPlay";
import { service } from "../../services";
import { FillingPotFeature, JackpotDisplayType, Settings } from "../../Settings";
import { Translator, translationMap } from "../../Translator";
import { ZIndex } from "../../ZIndex";
import { AnticipacionPIXIAPP } from "../AnticipacionPIXIAPP";
import { BigWinCountAnimationPIXIAPP } from "../BigWinCountAnimationPIXIAPP";
import { Bonus } from "../Bonus/Bonus";
import { SlotBonus } from "../Bonus/SlotBonus";
import { ExpandingWildsBulkConfig, ExpandingWildsBulkParam } from "../ExpandingWildBulk";
import { ExpandingWildsBulkPIXIAPP } from "../ExpandingWildBulkPIXIAPP";
import { ExpandingWildsReelParam } from "../ExpandingWildReel";
import { ExpandingWildsReelPIXIAPP } from "../ExpandingWildReelPIXIAPP";
import { FillingPotGeneric } from "../FillingPot/FillingPotGeneric";
import { ActionStats } from "../IHistoyGame";
import { MyCanvas } from "../MyCanvas";
import { Panel } from "../panel/panel";
import { ScatterRandomAwardCreateParams, ScatterRandomAwardResults } from "../ScatterRandomAward/ScatterRandomAward";
import { ScatterRandomAwardPIXI } from "../ScatterRandomAward/ScatterRandomAwardPIXI";
import { ShakeAnimation } from "../ShakeAnimation";
import { SlotFeature, SlotFeaturePIXI } from "../SlotFeature";
import { BonusFinish, BonusPickElement, BonusPickReveal, BonusRevealRemaining, BonusTotalResult, IBonusStartConfig, SymbolPosition } from "../SlotGame";
import { SlotGameMessages } from "../SlotGameScreenMessages";
import { ChangeSpeedParams } from "../SlotGameType1";
import { SlotGameType1Shared } from "../SlotGameType1Shared";
import { SlotSymbol } from "../SlotSymbol";
import { ReelMapper, ReelSymbolsToDisplay } from "../SpinAnimation/ReelMapper";
import { ReelSetMapper } from "../SpinAnimation/ReelSetMapper";
import { OnDeccelerationParams, ReelSpinAnimation } from "../SpinAnimation/ReelSpinAnimation";
import { SpinAnimation } from "../SpinAnimation/SpinAnimation";
import { SpinnableReels, SpinnableReelsParams } from "../SpinAnimation/SpinnableReels";
import { SpinnableReelsBigCanvas } from "../SpinAnimation/SpinnableReelsBigCanvas";
import { SpinTargetParams } from "../SpinAnimation/SpinTargetParams";
import { SymbolTypeAnim } from "../SpineSymbols/SymbolsCollection";
import { CanvasSprite } from "../Sprite/CanvasSprite";
import { ChangeStateType, GetStateNameCallback, StateChange, StateMachine } from "../StateMachine";
import { ICanDrawSymbol, SpecificSymbolsAnimation, SymbolPositionToAnimate } from "../SymbolsAnimation";
import { ITransition } from "../Transition/ITransition";
import { ITransitionFactory } from "../Transition/ITransitionFactory";
import { ITransitionFactoryPIXIAPP } from "../Transition/ITransitionFactoryPIXIAPP";
import { TransitionFactory } from "../Transition/TransitionFactory";
import { TransitionFactoryPIXIAPP } from "../Transition/TransitionFactoryPIXIAPP";
import { WinLineMarkers } from "../WinLineMarkers";
import { GenericWinLinesAnimationPIXIAPP, WinLinesAnimationParams, WinLinesDrawOrder } from "../WinLines/GenericWinLinesAnimation";
import { WinSquaresAnimationsSpinePIXIAPP } from "../WinLines/WinSquaresAnimationsSpinePIXIAPP";
import { IWinMessage } from "../WinMessage";
import { WinMessageAnimationPIXIAPP } from "../WinMessagePIXIAPP";
import { FreegameBonusParams, FreegameRunResult } from "./FreegameBonus";
import { FreegameMessages } from "./FreegameMessages";
import { FreegameSession } from "./FreegameSession";
import { FreegameStates } from "./FreegameState";
import { GenericPlusOnePIXIAPP, PlusOneParams } from "./GenericPlusOneAnimation";
import { IPlusOneFactory } from "./IPlusOneFactory";
import { SpritePlusOneFactory } from "./SpritePlusOneFactory";
import { assertNotNullish } from '../../debug';
import { AnticipationFactory, AnticipationParams, IAnticipation, IAnticipationFactoryParams } from '../AnticipationFactory/AnticipationFactory';

export interface TextureDialogLanguage {
	textureBonusIntro : any;
	textureBonusFinal : any;
}

export class FreegameBonusPIXIAPP extends SlotBonus implements Resourceful2, ICanDrawSymbol
{
	public override OnResize(): void {
		throw new Error('Method not implemented.');
	}
	public override CreateTransitionPixi(app? : PIXI.Container): void {
		//throw new Error("Method not implemented.");
		this.transitionView.CreateTransitionPixi(app);
	}
	public override DestroyTransition(): void {
		//throw new Error("Method not implemented.");
		this.transitionView.DestroyTransitionPixi();
	}
	public OnPicked(pickIndex: number): void {
		throw new Error("Method not implemented.");
	}
	public OnBonusPickElement(pickElement: BonusPickElement): void {
		throw new Error("Method not implemented.");
	}
	public OnBonusPickReveal(pickReveal: BonusPickReveal): void {
		throw new Error("Method not implemented.");
	}
	public OnBonusRevealRemaining(revealRemaining: BonusRevealRemaining): void {
		throw new Error("Method not implemented.");
	}
	
	protected readonly params: FreegameBonusParams;
	protected view: HTMLElement = null;
	protected readonly basepath: string;

	protected session: FreegameSession = null;

	protected noPickintroMessageContainer: HTMLElement = null;
	//protected reelsContainer: HTMLElement = null;
	protected finalMessageContainer: HTMLElement = null;

	//protected containers: Map<FreegameBonusContainer, HTMLElement> = new Map<FreegameBonusContainer, HTMLElement>();

	//protected pickElem: HTMLElement = null;

	//protected containers: HTMLElement[] = [];

	//protected logGroup: string = "FreegameBonus";
	protected stateMachine: StateMachine<FreegameStates> = new StateMachine<FreegameStates>(FreegameStates.Idle, this.logGroup, (state: FreegameStates) => FreegameStates[state]);

	// REELS
	protected spinnableReels: SpinnableReelsBigCanvas = null;
	protected spinAnimation: SpinAnimation = null;
	protected reelSetMapper: ReelSetMapper = null;

	// WIN LINES AND MARKERS
	protected winLinesAnimation: GenericWinLinesAnimationPIXIAPP= null;
	protected winLineMarkers: WinLineMarkers = null;

	// EXPANDING WILD FEATURE
	protected features: Map<string, SlotFeaturePIXI> = new Map<string, SlotFeaturePIXI>();
	//protected expandingWildsBulk: ExpandingWildsBulk = null;

	// +1 FREEGAME FEATURE
	protected plusOneAnimFactory: IPlusOneFactory = new SpritePlusOneFactory();
	protected plusOneAnim: GenericPlusOnePIXIAPP = null;
	protected _plusOneTarget: PIXI.Point;

	protected set plusOneTarget(value: PIXI.Point) {
		this._plusOneTarget = value;
		globalThis.plusOneTarget = value;

		console.log("plusOneTarget", value);
	}

	protected get plusOneTarget(): PIXI.Point {
		return this._plusOneTarget;
	}

	// spin delay, in millis
	//protected autoSpinTimer: SingleShotTimer= new SingleShotTimer(() => this.AutoSpin(), 3000);
	protected autoSpinTimer: number = null;
	
	//
	protected lastSpinResult: FreegameRunResult = null;

	// win lines or colelct can be interrupted, 
	// when interrupted, start new spin right away 
	protected spinInterrupted: boolean = false;

	protected winCreditAnimation: TweenMax = null;
	protected winValues: any = {balance:0,win:0};

	//protected symbolsAnimation: SymbolsAnimation = null;

	protected symbolsAnimation: SpecificSymbolsAnimation = null;

	protected winMessageAnimation: WinMessageAnimationPIXIAPP = null;
	protected shakeAnimation: ShakeAnimation = null;
	//protected fountainAnimation: FountainAnimation = null;
	protected bigWinCountAnimation: BigWinCountAnimationPIXIAPP = null;

	protected panel: Panel;


	protected lineMessage: HTMLElement = null;
	//protected denomMessage: HTMLElement = null;

	//protected transition: SceneTransition = null;

	protected audio: AudioManager = null;

	protected override parentresid: ResourceIdentifier = null;
	//protected resid: ResourceIdentifier = null;
	//protected screenProtocol: ScreenProtocol = null;
	//protected screenProtocolScope: ScreenProtocolScope = null;

	protected lineMessageLeft: HTMLElement = null;
	protected lineMessageRight: HTMLElement = null;

	protected clientState: ClientState = null;
	protected translator: Translator;

	protected robotPlay: RobotPlay;

	protected demoMessage:HTMLElement = null;

	//ADD VIDEO TRANSITION
	//protected transitionView:HTMLElement=null;
	//protected videotransition:HTMLVideoElement=null;

	//CREATE DIV TO TITLE 
	//protected titleSrpite:HTMLElement=null;
	protected titleSprite: CanvasSprite = null;
	protected VoicePlay:boolean=true;

	protected spinnableReelsParams: SpinnableReelsParams = {};
	protected systemContext: ISystemContext = null;

	//add new transition 
	protected transitionView: ITransition = null;
	protected transitionViewFactory:ITransitionFactory= new TransitionFactory();
	
	// protected wins: IWinMessage[] = [
	// 	{name: "big", winMultiplier: 10,file: "big_win_966x185_half"},
	// 	{name: "great", winMultiplier: 20, file: "great_win_1013x277_half"},
	// 	{name: "huge", winMultiplier: 30, file: "huge_win_966x202_half"},
	// 	{name: "awesome", winMultiplier: 40, file: "awesome_win_1119x213_half"},
	// 	{name: "amazing", winMultiplier: 50, file: "amazing_win_1185x252_half"}
	// ];
	//protected bigSymbolAnim: BigSymbolAnim = null;

	protected BonusName(): string
	{
		return "FreeGameBonus";
	}
	//Create some canvas for button text dialog
	protected buttonStartCanvas: MyCanvas;
	protected buttonExitCanvas: MyCanvas;
	//add BigBackground 
	protected backgroundFreeGameBonus: HTMLElement = null;

	//add ScatterRandomAward 
	protected scatterRandomAwardFeature: ScatterRandomAwardPIXI = null;
	protected bonusList: Map<Bonus, SlotBonus> = new Map<Bonus, SlotBonus>();

	//add cache symbol 
	//protected symbolCache: SymbolCache;

	//create interval for freegames
	protected timeoutAutoSpinFreeGames : ITimeout;
	protected timeoutStopsAnim : ITimeout;
	protected timeoutFreeGameWin : ITimeout;
	protected timeoutFreeGameFinalMessage : ITimeout;
	protected timeoutShowBonusIntoBonus : ITimeout;
	protected maxAdditionalFreegames : number;
	protected winLinesAnimFactor: number;
	
	protected jackpotSharedShow : JackpotSharedShow = null;
	protected anticipationFactory: AnticipationFactory = null;
	protected anticipationAnimation : IAnticipation = null;
	public constructor(gameName: string, params: FreegameBonusParams ) 
	{
		super(gameName, params);

		this.session = new FreegameSession();

		this.winLinesAnimFactor = params.winAnimationSpeedFactor;

		this.parentresid = params.resid;
		//this.translator=translator;
		this.translator=params.translator;
		//this.resid = params.resid.Add("FreeGameBonus");

		//this.screenProtocol = params.screenProtocol;
		//this.screenProtocolScope = params.screenProtocolScope.Add("FreeGameBonus");

		this.panel = params.panel;
		this.params = params;
		this.audio = params.audio;
		this.clientState = params.clientState;
		this.systemContext = params.systemContext.CreateSubContext("FreeGameBonus");
		this.bonusList = params.bonusList;
		

		this.view = document.createElement("div");
		this.view.classList.add(this.resid.Scope());
		this.view.classList.add("FreegameBonus");

		this.lineMessage = document.createElement("div");
		this.lineMessage.classList.add("line-message");

		this.basepath = Settings.ResourcesFolder + "multigame/slot/" + this.gameName + "/";


		this.backgroundFreeGameBonus = CreateElement("div",{
			classes:[this.resid.Scope(), "BackgroundBigFreeGame"],
			parentToAppend: this.view,
			style: {
				width: "100%",
				height: Scale.Hpx(1080*Settings.Screens),
				position: "absolute",
				bottom: Scale.Ypx(0),				
				backgroundSize: "100%",
				//zIndex:ZIndex.BackgroundBonus+"",
			}
		});

		if(params.slotGameMeta.Demo == true)
		{
			//demo message
			this.demoMessage = document.createElement("div");
			this.demoMessage.classList.add("demo-message");
			SetStyles(this.demoMessage,
			{
				position:"absolute",
				top:"8%",
				left:"86%",
				width:"16%",
				height:"8%",
				fontSize:"99px",
				letterSpacing:"5px",
				fontFamily:"NotoSansDisplay-ExtraBold",
				color:"rgba(255, 0, 0, 1)",
				display:"flex",
				justifyContent:"center",
				alignItems:"center",
				transform: "rotate(45deg)",
			})
			
			this.demoMessage.innerHTML = "DEMO";
		}


		
		this.maxAdditionalFreegames =  (this.params.bonusConfiguration.FeatureConfigurations.find(feature => feature.FeatureType == "PlusOneFeature" ) as PlusOneFeatureConfiguration )?.MaxAdditionalFreegames ?? 10;		
		//this.denomMessage = document.createElement("div");
		//this.denomMessage.classList.add("denom-message");

		this.stateMachine.SetCallback(FreegameStates.IntroTransition, StateChange.Begin, () => this.OnIntroTransitionBegin());
		this.stateMachine.SetCallback(FreegameStates.IntroTransition, StateChange.End, () => this.OnIntroTransitionEnd());


		//////// intro with pick options
		this.stateMachine.SetCallback(FreegameStates.IntroMessage, StateChange.Begin, () => this.OnIntroMessageBegin());
		this.stateMachine.SetCallback(FreegameStates.IntroMessage, StateChange.End, () => this.OnIntroMessageEnd());

		// this.stateMachine.SetCallback(FreegameStates.Pick, StateChange.Begin, () => this.OnPickBegin());
		// this.stateMachine.SetCallback(FreegameStates.PickedMessage, StateChange.Begin, () => this.OnPickedMessageBegin());
		// this.stateMachine.SetCallback(FreegameStates.PickedMessage, StateChange.End, () => this.OnPickedMessageEnd());
		//////////////////////

		////////// intro without pick options
		this.stateMachine.SetCallback(FreegameStates.NoPickIntro, StateChange.Begin, () => this.OnNoPickIntroMessageBegin());
		this.stateMachine.SetCallback(FreegameStates.NoPickIntro, StateChange.End, () => this.OnNoPickedMessageEnd());

		/////////////////////

		this.stateMachine.SetCallback(FreegameStates.WaitFirstSpin, StateChange.Begin, () => this.OnWaitFirstSpinBegin());
		//this.stateMachine.SetCallback(FreegameStates.Spin, StateChange.End, () => this.OnSpinEnd());

		this.stateMachine.SetCallback(FreegameStates.Spin, StateChange.Begin, () => this.OnSpinBegin());
		this.stateMachine.SetCallback(FreegameStates.Spin, StateChange.End, () => this.OnSpinEnd());

		this.stateMachine.SetCallback(FreegameStates.FillingPot, StateChange.Begin, () => this.OnFeaturesFillingPot());
		//this.stateMachine.SetCallback(FreegameStates.Features, StateChange.End, () => this.OnFeaturesBegin());

		this.stateMachine.SetCallback(FreegameStates.Features, StateChange.Begin, () => this.OnFeaturesBegin());
		this.stateMachine.SetCallback(FreegameStates.Features, StateChange.End, () => this.OnFeaturesEnd());

		this.stateMachine.SetCallback(FreegameStates.BigWin, StateChange.Begin, () => this.OnBigWinBegin());
		this.stateMachine.SetCallback(FreegameStates.BigWin, StateChange.End, () => this.OnBigWinEnd());

		this.stateMachine.SetCallback(FreegameStates.Win, StateChange.Begin, () => this.OnWinBegin());
		this.stateMachine.SetCallback(FreegameStates.Win, StateChange.End, () => this.OnWinEnd());


		this.stateMachine.SetCallback(FreegameStates.Collect, StateChange.Begin, () => this.OnCollectBegin());

		this.stateMachine.SetCallback(FreegameStates.Bonus, StateChange.Begin, () => this.OnBonusBegin());
		this.stateMachine.SetCallback(FreegameStates.Bonus, StateChange.End, () => this.OnBonusEnd());

		
		this.stateMachine.SetCallback(FreegameStates.SpinIdle, StateChange.Begin, () => this.OnSpinIdleBegin());
		this.stateMachine.SetCallback(FreegameStates.SpinIdle, StateChange.End, () => this.OnSpinIdleEnd());

		this.stateMachine.SetCallback(FreegameStates.FinalMessage, StateChange.Begin, () => this.OnFinalMessageBegin());
		this.stateMachine.SetCallback(FreegameStates.FinalMessage, StateChange.End, () => this.OnFinalMessageEnd());

		this.stateMachine.SetStateChangeCallback( (oldState: FreegameStates, newState: FreegameStates, stateNameCallback: GetStateNameCallback<FreegameStates>) => {
			// Log.Debug(this.logGroup, "Changing state " + stateNameCallback(oldState) + " to " + stateNameCallback(newState));
		});
		this.robotPlay = params.robotPlay;

		this.timeoutAutoSpinFreeGames = this.systemContext.TimingContext().CreateTimeout("timeoutAutoSpinFreeGames", 2000, () => {
			this.AutoSpin()
		})

		this.timeoutStopsAnim = this.systemContext.TimingContext().CreateTimeout("timeoutStopsAnim", 4000, () => {
			try {
				this.spinnableReels.StopSymbolsAnim();
				//this.currentBonus.TriggerAnimationStopped();
				//this.DisableSymbolsAnimation();
			} catch (error) {
				Log.Error(this.logGroup, "Error stops symbol", error);
			}
		});

		this.timeoutFreeGameWin = this.systemContext.TimingContext().CreateTimeout("timeoutFreeGameWin", 2000, () => {
			this.audio.Stop(this.parentresid.ScopedResourceName("bigwin"));
			this.shakeAnimation.Stop();
			this.stateMachine.ChangeState(FreegameStates.Win);
		});

		this.timeoutFreeGameFinalMessage = this.systemContext.TimingContext().CreateTimeout("timeoutFreeGameFinalMessage", 1000, () => {
			this.stateMachine.ChangeState(FreegameStates.FinalMessage);
			// Hide the container using GSAP
			if (this.bonusGameInfoStatsPIXIAPP != null) gsap.to(this.bonusGameInfoStatsPIXIAPP, { alpha: 0, duration: 1 });
			//show container win awward using GSAP
			let xPosition = 0;
			if (Settings.Screens == 2 || Settings.Enable2plus1 == true) {
				xPosition = Scale.X(36);
				if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPyramidShared2S) xPosition = Scale.X(614);
			}

			if (this.bonusGameAwardViewPIXIAPP != null) gsap.to(this.bonusGameAwardViewPIXIAPP, { x: xPosition, duration: 1, ease: Elastic.easeOut.config(0.50, 0.4) });

		});		

		let timeoutShowBonusIntoBonus = 0;
		if (Settings.fillingPotFeature == FillingPotFeature.Enable) {
			this.skinAttachmentFillingPotFeature = params.skinAttachmentFillingPotFeature;
			this.CreateFillingPot();
			timeoutShowBonusIntoBonus += 3600;
		}	

		this.timeoutShowBonusIntoBonus = this.systemContext.TimingContext().CreateTimeout("", timeoutShowBonusIntoBonus, () => {
			this.fillingPotFeature?.StopAnim();							
			this.audio.Stop(this.resid.ScopedResourceName("background"));			
			this.OnBonusRunFinished(this.nextBonusData);
			this.nextBonusData = null;					
		});		

		this.winMessageAnimation = new WinMessageAnimationPIXIAPP(this.audio);

		if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotStepShared) {
			if (enableJackpotSharedMap[Settings.JackpotDisplayType] == true) {
				this.jackpotSharedShow = new JackpotSharedShow(this.audio, this.resid);
			}
		}	



		let command: string = "";
		window.addEventListener('keydown', (e) => {
			command += e.key.toLowerCase();

			if (command.endsWith("setpos"))
			{
				this.CreatePlusOneTarget();
			}
		})
	}

	protected fillingPotNextTask : ITimeout = null;
	protected fillingPotHitBonues : ITimeout = null;
	//protected fillingPotFeature: FillingPotGeneric = null;
	protected skinAttachmentFillingPotFeature : number = 1;
	protected CreateFillingPot() {
		
		this.fillingPotFeature = new FillingPotGeneric({
			systemContext: this.systemContext, 
			initData: this.params.initData,
			resid: this.resid,			
			logGroup: this.logGroup,			
			//viewSize: this.viewSize,
			gameResourcesBasePath :  this.basepath + "resources/", 	
			commonResourcesPath :  this.params.commonBonusResourcesBasePath + "resources/FillingPot/",     
			//EnabledBets: this.initData.EnabledBets,FillingPotvPopet
			gameName : this.gameName,
			audio : this.audio,
			skinAttachment : this.skinAttachmentFillingPotFeature,
			windowRectangle : this.params.windowRectangle,
			clientState : this.params.clientState,
			//poppetPlusPot : this.params.gameConfig.poppetPlusPot != null ? this.params.gameConfig.poppetPlusPot : false 
		});		

		this.fillingPotNextTask = this.systemContext.TimingContext().CreateTimeout("fillingPotUpdate", 2000, () => {			
			this.stateMachine.ChangeState(FreegameStates.Features, null, ChangeStateType.NextTask);
		});

		this.fillingPotHitBonues = this.systemContext.TimingContext().CreateTimeout("fillingPotUpdate", 500, () => {
			// this.fillingPotFeature?.StartIncrement({
			// 	BonusWin: true,
			// 	ScatterCordinates: null
			// })

			// let bonusName : string = "";
			// this.lastSpinAction.Triggers.forEach(bonusTriggerResult => {
			// 	BonusWillUpdateFillingPotFeature.forEach(b => {
			// 		if (b == bonusTriggerResult.Bonus && bonusTriggerResult.WillTrigger == true) {
			// 			//change true bonus win for play all anim whit spine on FillingPotFeature 						
			// 			bonusName = b;
			// 			this.fillingPotFeature?.StartBonusWin(bonusName);			
			// 		}else if(bonusTriggerResult.WillTrigger == true){
			// 			bonusName = "Freegames"
			// 			this.fillingPotFeature?.StartBonusWin(bonusName);		
			// 		} 					
			// 	})
			// });
			
			
		});
	}

	public async PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {

		await this.fillingPotFeature?.PrepareResources(loadingStage, resourceManager);
		// await SlotGameType1Shared.Instance().ResourcesPrepare(loadingStage, resourceManager , this.params.jackpotRequired);

		if (loadingStage == LoadingStage.GamesPreload)
		{
			await this.PrepareSpineResources(resourceManager);
			await this.winMessageAnimation.PrepareResources(resourceManager);
		}
		else if (loadingStage == LoadingStage.Games)
		{
			
			//move for create different family for feature 
			await this.fillingPotFeature?.CreateFamilyAndPrepareResources(resourceManager,this.params.gameConfig.poppetPlusPot != null ? this.params.gameConfig.poppetPlusPot : false, this.spinnableReels);
			await this.BasePrepare(resourceManager);

			//Background and Construct Reels
			await this.PrepareBackgroundReel(resourceManager);

			await this.ConstructReels();

		let params:PlusOneParams={
			viewSize: this.params.screenSize,
			spinnableReels: this.spinnableReels,
			logGroup: this.logGroup,
			resid: this.resid,
			bonusName: this.bonusName,
			maxAdditionalFreegames: this.maxAdditionalFreegames,
			gameBonusResourcesBasePath: this.params.gameBonusResourcesBasePath,
			commonBonusResourcesBasePath: this.params.commonBonusResourcesBasePath
		};

			this.plusOneAnim = this.plusOneAnimFactory.CreatePlusOnePIXIAPP(params);	
			//this.bigSymbolAnim = new BigSymbolAnim(this.params.availableSymbolsMap, this.spinnableReels);

			/*
			this.audio.AddTrack(new Track(this.params.gameResourcesBasePath + "tracks/background" + Settings.audioFormat, this.resid.ScopedResourceName("background")));
			this.audio.AddTrack(new Track(this.params.gameResourcesBasePath + "tracks/backgroundend" + Settings.audioFormat, this.resid.ScopedResourceName("backgroundend")));
			this.audio.AddTrack(new Track(this.params.gameResourcesBasePath + "tracks/transition" + Settings.audioFormat, this.resid.ScopedResourceName("transition")));
			this.audio.AddTrack(new Track(this.params.gameResourcesBasePath + "tracks/pick" + Settings.audioFormat, this.resid.ScopedResourceName("pick")));
			this.audio.AddTrack(new Track(this.params.gameResourcesBasePath + "tracks/remaining" + Settings.audioFormat, this.resid.ScopedResourceName("remaining")));

			this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/bonustriggered" + Settings.audioFormat, this.resid.ScopedResourceName("triggered")));
			this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/plusone" + Settings.audioFormat, this.resid.ScopedResourceName("plusone")));
			this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/plusonemove" + Settings.audioFormat, this.resid.ScopedResourceName("plusonemove")));
			*/
			await this.PrepareWinLines(resourceManager);
			await this.AudioPrepare(resourceManager);

			await this.FeaturesPrepare(resourceManager);
			await this.BigWinPrepare(resourceManager);

			await this.PrepareHistory(resourceManager);
			await this.PrepareAnticipation(resourceManager)

		}
	}

	protected async PrepareAnticipation(resourceManager: IWriteOnlyResourceManager){

		const anticipationParams: IAnticipationFactoryParams ={
			playWindow: this.params.initData.PlayWindow,
			symbolSize: this.spinnableReels.GetSymbolSize(),
			gameName: this.gameName,
			anticipationType: this.params.gameConfig.anticipationType
		}
		this.anticipationFactory = new AnticipationFactory(anticipationParams);	
		this.anticipationAnimation = this.anticipationFactory.CreateAnticipation();

		await this.anticipationAnimation?.PrepareResources(resourceManager);
	}

	protected async PrepareSpineResources (resourceManager: IWriteOnlyResourceManager){
		let bonusResorucesSpine : string = `${Settings.ResourcesFolder}multigame/slot/common/resources/BonusResorucesSpine` 
		//SpinRemaniningPrepare 
		resourceManager.AddGlobal(new JSONResource(`${bonusResorucesSpine}/WinCount/WinCount.json`, ResourceIdentifier.Global.ScopedResourceName(`WinCountSpineJson`)));
		resourceManager.AddGlobal(new AtlasResource(`${bonusResorucesSpine}/WinCount/WinCount.atlas`, ResourceIdentifier.Global.ScopedResourceName(`WinCountSpineATLAS`)));

		//Bonus Award 
		//winAwardFrame Prepare
		let pathWinAwardBonusJSON = `${bonusResorucesSpine}/WinAwardBonus/WinAwardBonus.json`;
		let pathWinAwardBonusATLAS = `${bonusResorucesSpine}/WinAwardBonus/WinAwardBonus.atlas`;
		if (Settings.JackpotDisplayType == JackpotDisplayType.RainbowGirls) {
			pathWinAwardBonusJSON = `${bonusResorucesSpine}/WinAwardBonusStyleJackpot/WinAwardBonusStyleJackpot.json`;
			pathWinAwardBonusATLAS = `${bonusResorucesSpine}/WinAwardBonusStyleJackpot/WinAwardBonusStyleJackpot.atlas`;
		}

		//SpinRemaniningPrepare 
		resourceManager.AddGlobal(new JSONResource(pathWinAwardBonusJSON, ResourceIdentifier.Global.ScopedResourceName(`WinAwardBonusSpineJson`)));
		resourceManager.AddGlobal(new AtlasResource(pathWinAwardBonusATLAS, ResourceIdentifier.Global.ScopedResourceName(`WinAwardBonusSpineATLAS`)));

		//BonusTitlePrepare 
		resourceManager.AddGlobal(new JSONResource(`${bonusResorucesSpine}/BonusWinTitle/BonusWinTitle.json`, ResourceIdentifier.Global.ScopedResourceName(`BonusWinTitleJson`)));
		resourceManager.AddGlobal(new AtlasResource(`${bonusResorucesSpine}/BonusWinTitle/BonusWinTitle.json`, ResourceIdentifier.Global.ScopedResourceName(`BonusWinTitleATLAS`)));


		await this.jackpotSharedShow?.PrepareResources(resourceManager);


		////create Title Freegames Spine
		//resourceManager.AddGlobal(new JSONResource(`${bonusResorucesSpine}/FreeGamesBonusTitle/FreeGamesBonusTitle.json`, ResourceIdentifier.Global.ScopedResourceName(`FreeGamesBonusTitleJson`)));
		//resourceManager.AddGlobal(new AtlasResource(`${bonusResorucesSpine}/FreeGamesBonusTitle/FreeGamesBonusTitle.json`, ResourceIdentifier.Global.ScopedResourceName(`FreeGamesBonusTitleAtlas`)));

		//SpinRemaniningPrepare 
		resourceManager.AddGlobal(new JSONResource(`${bonusResorucesSpine}/SpinsRemaining/SpinsRemaining.json`, ResourceIdentifier.Global.ScopedResourceName(`SpinsRemainingSpineJson`)));
		resourceManager.AddGlobal(new AtlasResource(`${bonusResorucesSpine}/SpinsRemaining/SpinsRemaining.atlas`, ResourceIdentifier.Global.ScopedResourceName(`SpinsRemainingSpineATLAS`)));
		
	}



	protected wins: IWinMessage[] = [
		{name: "big", winMultiplier: 0,file: ""},
		{name: "great", winMultiplier: 0, file: ""},
		{name: "huge", winMultiplier: 0, file: ""},
		{name: "awesome", winMultiplier: 0, file: ""},
		{name: "amazing", winMultiplier: 0, file: ""}
	];
	
	public AudioPrepare(resourceManager: IWriteOnlyResourceManager)
	{ 
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/background" + Settings.audioFormat, this.resid.ScopedResourceName("background")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/backgroundend" + Settings.audioFormat, this.resid.ScopedResourceName("backgroundend")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/transition" + Settings.audioFormat, this.resid.ScopedResourceName("transitionaudio")));
		//this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/pick" + Settings.audioFormat, this.resid.ScopedResourceName("pick")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/remaining" + Settings.audioFormat, this.resid.ScopedResourceName("remaining")));

		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/bonustriggered" + Settings.audioFormat, this.resid.ScopedResourceName("triggered")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/plusone" + Settings.audioFormat, this.resid.ScopedResourceName("plusone")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/plusonemove" + Settings.audioFormat, this.resid.ScopedResourceName("plusonemove")));
	    this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/final" + Settings.audioFormat, this.resid.ScopedResourceName("final")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/freegameintro" + Settings.audioFormat, this.resid.ScopedResourceName("intro")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/freegame" + Settings.audioFormat, this.resid.ScopedResourceName("freegame")));		

		for (let i = 0; i < this.wins.length; i++) {
			this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/voice/"+this.wins[i].name + Settings.audioFormat, this.resid.ScopedResourceName(this.wins[i].name)));
		}
		this.audio.AddTrack(new Track(this.basepath + "resources/tracks/reelSpinStop"+Settings.audioFormat, this.resid.ScopedResourceName("reelstop")));
	}

	public async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {

		await this.fillingPotFeature?.ResourcesLoaded(loadingStage, resourceManager);
		// SlotGameType1Shared.Instance().ResourcesLoaded(loadingStage, resourceManager , this.params.jackpotRequired);

		if (loadingStage == LoadingStage.GamesPreload)
		{
			await this.CreateTextureBonusTitleSpineLoaded(resourceManager)
		}
		else if (loadingStage == LoadingStage.Games)
		{
			//this.view.innerHTML += resourceManager.Get<HTMLResource>(this.resid.ScopedResourceName("html")).html;

			await this.BaseLoaded(resourceManager);

			

			//this.PrepareMessage(resourceManager);
			//this.SetContainers(resourceManager);

			this.LoadedHistory(resourceManager);


		
			// WIN LINES AND MARKERS
			//this.winLines = new WinLines(this.params.windowRectangle, this.spinnableReels.GetWindowSymbolSize(), this.params.playlines);
			//this.winLinesAnimation = new WinLinesAnimation(this.winLines/* , this.audio.Track(this.parentresid.ScopedResourceName("linecount")).Duration() * 2 * 1000 */);


			await this.winLinesAnimation.ResourcesLoaded(resourceManager);

			// // // WIN LINES AND MARKERS view
			//this.view.appendChild(this.winLinesAnimation.View());
			// this.reelsContainer.appendChild(this.winLineMarkers.LeftView());
			// this.reelsContainer.appendChild(this.winLineMarkers.RightView());


			this.symbolsAnimation = new SpecificSymbolsAnimation(this.params.symbolSpriteAnims, this.spinnableReels, this.reelSetMapper, this);

			//this.symbolsAnimation = new SymbolsAnimation(this.params.symbolSpriteAnims, this.spinnableReels, this.reelSetMapper);

			await this.FeaturesLoaded(resourceManager);


			this.BigWinLoaded(resourceManager);

			//this.bonusTriggerAnimation = new SpecificSymbolsAnimation(this.params.symbolSpriteAnims, this.spinnableReels, this.reelSetMapper, this);

			// this.View().querySelector(".header").appendChild(this.translator.Anchor(() => this.translator.t.fregameheader));
			// this.View().querySelector("#contents1").appendChild(this.translator.Anchor(() => this.translator.t.freegamemassage1));
			// this.View().querySelector(".bonusName").appendChild(this.translator.Anchor(() => this.translator.t.freegamemassage3));
			// this.View().querySelector("#contents2").appendChild(this.translator.Anchor(() => this.translator.t.freegamemassage2));
			// this.View().querySelector("#contents3").appendChild(this.translator.Anchor(() => this.translator.t.freegamemassage4));

			// this.View().querySelector(".startbut").appendChild(this.translator.Anchor(() => this.translator.t.freegamemassage5));

			if(this.params.slotGameMeta.Demo == true)
			{
				this.view.appendChild(this.demoMessage);
			}

			//this.TitleLoaded(resourceManager);
			//this.view.appendChild(this.plusOneAnim.View());


			
			// //reels resources prepare Texture for pixi.js			
			let reelImageResource = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["reel", "image"]));				
			let reelBackgroundTexture = PIXI.Texture.from(reelImageResource.DecodedImage());
			

			let reelImageMaskResource = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["reelMask", "image"]));	
			let reelBackgroundMaskTexture = PIXI.Texture.from(reelImageMaskResource.DecodedImage());

			this.spinnableReels.ResourcesLoaded(this.params.pixiSpritesByName , reelBackgroundTexture, reelBackgroundMaskTexture);
			await this.LoadedFillingPot(resourceManager);
			this.LoadedReels();
			// REELS
			//this.reelsContainer.appendChild(this.spinnableReels.GetView());

			//this.symbolCache = new SymbolCache(this.params.symbolSpriteAnimsByName, this.spinnableReels.GetSymbolSize(), this.resid);
			await this.winMessageAnimation.ResourcesLoaded(resourceManager);
			// // messages			
			for (let i = 0; i < this.wins.length; i++) {
				// 	let message = new WinMessage(this.wins[i].name, resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("winmsg").Add(this.wins[i].name)).sprite, this.wins[i].winMultiplier, this.audio.Track(this.resid.ScopedResourceName(this.wins[i].name)));
				// 	this.winMessageAnimation.AddMessage(message);
				await this.winMessageAnimation.AddSound(this.wins[i].name, this.audio.Track(this.resid.ScopedResourceName(this.wins[i].name)));
			}

			await this.jackpotSharedShow?.ResourcesLoaded(resourceManager);

			await this.anticipationAnimation?.ResourcesLoaded(resourceManager);
		}
	}


	//protected jsonBonusTitleSpine: ISkeletonData = null;
	protected jsonWinCountSpine: ISkeletonData = null;
	//protected jsonSpinsRemainingSpine: ISkeletonData = null;
	protected jsonWinAwardBonusSpine: ISkeletonData = null;
	protected jsonBonusWinTitleSpine: ISkeletonData = null;
	protected jsonSpinsRemainingSpine: ISkeletonData = null;
	protected async CreateTextureBonusTitleSpineLoaded(resourceManager: IReadOnlyResourceManager){		
		//create WinCountSpine 
		let spineWinCountSpineJson = resourceManager.Get<JSONResource>(ResourceIdentifier.Global.ScopedResourceName(`WinCountSpineJson`));
		let spineWinCountAssets = await PIXI.Assets.load(spineWinCountSpineJson.path);
		this.jsonWinCountSpine = spineWinCountAssets.spineData;
		spineWinCountSpineJson = null;
		spineWinCountAssets = null;


		//Create Award bonus 
		let spineWinAwardBonusSpineJson = resourceManager.Get<JSONResource>(ResourceIdentifier.Global.ScopedResourceName(`WinAwardBonusSpineJson`));
		let spineWinAwardBonusAssets = await PIXI.Assets.load(spineWinAwardBonusSpineJson.path);
		this.jsonWinAwardBonusSpine = spineWinAwardBonusAssets.spineData;

		spineWinAwardBonusSpineJson = null;
		spineWinAwardBonusAssets = null;
 
		let bonusWinTitleJson = resourceManager.Get<JSONResource>(ResourceIdentifier.Global.ScopedResourceName(`BonusWinTitleJson`));
		let bonusWinTitlAssets = await PIXI.Assets.load(bonusWinTitleJson.path).finally(() => {
			PIXI.Assets.cache.remove(bonusWinTitleJson.path);
		});;
		this.jsonBonusWinTitleSpine =bonusWinTitlAssets.spineData;

		bonusWinTitleJson = null;
		bonusWinTitlAssets = null;

		//Spins Remaning Spin texture prepare Asset 
		let spineSpinsRemainingSpineJson = resourceManager.Get<JSONResource>(ResourceIdentifier.Global.ScopedResourceName(`SpinsRemainingSpineJson`));
		let spineSpinsRemainingAssets = await PIXI.Assets.load(spineSpinsRemainingSpineJson.path);
		this.jsonSpinsRemainingSpine = spineSpinsRemainingAssets.spineData;

	}

	//create FillingPot 
	protected async LoadedFillingPot(resourceManager: IReadOnlyResourceManager) {
		if (!this.fillingPotFeature)
		{
			// not enabled;
			return;
		}
		
		//this.view.appendChild(this.fillingPotFeature?.View());
			// redraw reels when context recovers
		this.fillingPotFeature.OnCreatedCallback = () => {
			//console.log("CallBackForFillingPot");
			this.spinnableReels.Create(this.fillingPotFeature?.GetReelContainer());
			//this.ReelsRestored();
		};
		this.fillingPotFeature.OnDestroyCallback = () => {
			//console.log("CallBackForFillingPot");
			this.spinnableReels.Destroy("Destroy FreegameBonusPIXIAPP");
			//this.ReelsRestored();
		};
	}


	protected SetContainers(resourceManager: IReadOnlyResourceManager): void
	{
		// this.PrepareNoPickIntroMessage(resourceManager);
		// this.PrepareFinalMessage(resourceManager);
		// this.PrepareReelsContainer(resourceManager);
		// this.containers.set(FreegameBonusContainer.NoPickIntro, this.noPickintroMessageContainer);
		// this.containers.set(FreegameBonusContainer.Reels, this.reelsContainer);
		// this.containers.set(FreegameBonusContainer.FinalMessage, this.finalMessageContainer);
	}
	//Create TextCanvas for button start and end bonus
	protected ButtonCanvasText() : MyCanvas
	{
		let buttonText = new MyCanvas(new Size(Scale.W(454), Scale.H(300)), {
			style: {
				left: Scale.Xpx(8),
				top: Scale.Ypx(12),
				position: "relative",
				zIndex: ""+ ZIndex.BonusWin
			}
		});

		return buttonText;
		
	}
	//protected fontHeight:number=Scale.fh(135);
	public SetTextCanvas(text: string, canvas: MyCanvas , fontHeight:number=Scale.fh(135))
	{
		canvas.context.clearRect(0, 0, canvas.size.Width,canvas.size.Height);

		let gradient = canvas.context.createLinearGradient( 
			canvas.size.Width / 2, 
			canvas.size.Height / 2 - fontHeight/2, 
			canvas.size.Width / 2, 
			canvas.size.Height /2 + fontHeight/2
		);

		gradient.addColorStop(0,    "#F2E416");
		gradient.addColorStop(0.25, "#F2BE22");
		gradient.addColorStop(0.50, "#C2760E");
		gradient.addColorStop(0.75, "#F2BE22");
		gradient.addColorStop(1,    "#F2E416");

		canvas.context.fillStyle = gradient;

		canvas.context.font = "bold " + fontHeight + "px " + this.resid.ScopedResourceName("bigwincount") ;
		canvas.context.textBaseline = "middle";
		canvas.context.textAlign="center";
		canvas.context.lineJoin="round"; //Experiment with "bevel" & "round" for the effect you want!
		canvas.context.miterLimit = 2;

		canvas.context.strokeStyle = "black";
		canvas.context.lineWidth = Scale.fh(10);
		canvas.context.strokeText(text, canvas.size.Width / 2, canvas.size.Height / 2);
		canvas.context.strokeText(text, canvas.size.Width / 2, canvas.size.Height / 2);
		canvas.context.fillText(text,   canvas.size.Width / 2, canvas.size.Height / 2);
		canvas.RestoreContext();

		text = null;
		gradient = null;		
	}

	protected PrepareNoPickIntroMessage(resourceManager: IReadOnlyResourceManager): void
	{
		this.noPickintroMessageContainer = CreateElement("div", {classes:["noPickintroMessageContainer"], parentToAppend: this.view, 
			style:
			{
				position:"relative",
				top:"0px",
				left:"0px",
				width:"100%",
				height:"100%",
				zIndex:ZIndex.BonusCofirmMessage.toString(),
			}
		});

		let messageContainer: HTMLElement = CreateElement("div", {classes:["noPickMessageContainer"], parentToAppend: this.noPickintroMessageContainer,
			style:
			{
				width:"100%",
				height:"100%",
				display:"flex",
				justifyContent:"center",
				alignItems:"center",
				color:"yellow",
				fontFamily: this.resid.ScopedResourceName("font"),
			}
		});

		let dialog: HTMLElement = CreateElement("div",{classes:["dialog"],parentToAppend:messageContainer, 
			style:
				{
					position:"relative",
					width: Scale.Hpx(1152),
					height:Scale.Wpx(648),
					backgroundSize: "contain",
					backgroundPosition: "center",
					backgroundRepeat: "no-repeat",
					backgroundImage :resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["dialog", "image"])).CssBackground(),
				}
		});

		let freeGameSymbolFGMessageSpanish: HTMLElement = CreateElement("span",{
			style:
			{
				position: "absolute",
				width: Scale.Wpx(1152),
				height: Scale.Hpx(512),
				backgroundSize: "contain",
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat",
				backgroundImage :resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["intro", "spanish"])).CssBackground(),


			}
		});
		let freeGameSymbolFGMessageEnglish: HTMLElement = CreateElement("span",{
			style:
			{
				position: "absolute",
				width: Scale.Wpx(1152),
				height: Scale.Hpx(512),
				backgroundSize: "contain",
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat",
				backgroundImage :resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["intro", "english"])).CssBackground(),


			}
		});
		
		dialog.appendChild(this.translator.Anchor(()=> this.translator.t.BigFG(freeGameSymbolFGMessageSpanish.outerHTML, freeGameSymbolFGMessageEnglish.outerHTML)));
		

		let buttonContainer: HTMLElement = CreateElement("div", {classes:["buttonContainer"], parentToAppend:dialog, 
			style:
			{
				position:"absolute",
				bottom: Scale.Ypx(-50),
				width:"100%",
				height: Scale.Hpx(300),
				display: "flex",
				justifyContent: "center",
				alignItems: "center"
			}
		})
		
		let button: HTMLElement = CreateElement("div", {classes:["button"], parentToAppend:buttonContainer, 
			style:
			{
				width:Scale.Wpx(600),
				height:Scale.Hpx(300),
				fontSize:Scale.fhpx(100),
				display: "flex",
				justifyContent:"center",
				alignItems:"center",
				backgroundSize: "contain",
				backgroundPosition: "center",
				backgroundRepeat:"no-repeat",
				backgroundImage :resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["button", "image"])).CssBackground(),
			}
		});

		//button.appendChild(this.translator.Anchor(()=> this.translator.t.freegameStart));
		this.buttonStartCanvas = this.ButtonCanvasText();		
		this.SetTextCanvas(this.translator.t.freegameStart, this.buttonStartCanvas);
		button.appendChild(this.buttonStartCanvas.View());
		this.translator.SetOnLanguageChangedCallback(() => this.SetTextCanvas(this.translator.t.freegameStart, this.buttonStartCanvas));
	
	


		AddMouseDownListener(button, () => {
			if (this.stateMachine.State() == FreegameStates.NoPickIntro) {
				// Log.Debug(this.logGroup, "Intro message confirmed");
				this.stateMachine.ChangeState(FreegameStates.WaitFirstSpin);
			}
			else {
				Log.Error(this.logGroup, "Can't confirm intro message, current state: " + FreegameStates[this.stateMachine.State()] + ", required state: " + FreegameStates[FreegameStates.IntroMessage]);
			}
		});

	}

	protected PrepareFinalMessage(resourceManager: IReadOnlyResourceManager): void
	{
		this.finalMessageContainer = CreateElement("div", {classes:["finalMessageContainer"], parentToAppend: this.view, 
			style:
			{
				position:"relative",
				top:"0px",
				left:"0px",
				width:"100%",
				height:"100%",
				zIndex:ZIndex.BonusCofirmMessage.toString(),
			}
		});

		let messageContainer: HTMLElement = CreateElement("div", {classes:["messageContainer"], parentToAppend: this.finalMessageContainer,
			style:
			{
				width:"100%",
				height:"100%",
				display:"flex",
				justifyContent:"center",
				alignItems:"center",
				color:"yellow",
				fontFamily: this.resid.ScopedResourceName("font"),

			}
		});

		let dialog: HTMLElement = CreateElement("div",{classes:["dialog"],parentToAppend:messageContainer, 
			style:
				{
					position:"relative",
					width:  Scale.Wpx(1152),
					height: Scale.Hpx(648),
					backgroundSize: "contain",
					backgroundPosition: "center",
					backgroundRepeat: "no-repeat",
					backgroundImage :resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["dialog", "image"])).CssBackground(),
				}
		});

		// let message: HTMLElement = CreateElement("div", {classes:["message"], parentToAppend:dialog, style:{position:"relative", top:"35px", fontSize:"50px", height:"50%", textAlign:"center"}});
		// let finished: HTMLElement = CreateElement("div", {classes:["congratulations"], parentToAppend:message, style:{height:"100px", fontSize:"90px"}});
		// let youHaveWon: HTMLElement = CreateElement("div", {classes:["youHaveWon"], parentToAppend:message});
		// let creditsCont: HTMLElement = CreateElement("div", {classes:["creditsCont"], parentToAppend:message, });
		// let bonusCredits: HTMLElement = CreateElement("span", {classes:["bonusCredits"], parentToAppend:creditsCont, style:{fontSize:"90px"}});
		// let CreditsTxt: HTMLElement = CreateElement("div", {classes:["CreditsTxt"], parentToAppend:message});
		// let pressExit: HTMLElement = CreateElement("div", {classes:["pressExit"], parentToAppend:message});

		// finished.appendChild(this.translator.Anchor(() => this.translator.t.freeGameFinished));
		// youHaveWon.appendChild(this.translator.Anchor(() => this.translator.t.freeGameYouHaveWon));
		// //creditsCont.appendChild(this.translator.Anchor(() => this.translator.t.freegameFreegame));
		// //bonusCredits.appendChild(this.translator.Anchor(() => this.translator.t.freegameBonus));
		// CreditsTxt.appendChild(this.translator.Anchor(() => this.translator.t.freeGameCredits));
		// pressExit.appendChild(this.translator.Anchor(()=> this.translator.t.freeGamePressExit));

		let freeGameSymbolFGMessageSpanish: HTMLElement = CreateElement("span",{
			style:
			{
				position: "absolute",
				width: Scale.Wpx(1152),
				height: Scale.Hpx(512),
				backgroundSize: "contain",
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat",
				backgroundImage :resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["end", "spanish"])).CssBackground(),


			}
		});
		let freeGameSymbolFGMessageEnglish: HTMLElement = CreateElement("span",{
			style:
			{
				position: "absolute",
				width: Scale.Wpx(1152),
				height: Scale.Hpx(512),
				backgroundSize: "contain",
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat",
				backgroundImage :resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["end", "english"])).CssBackground(),


			}
		});
		
		dialog.appendChild(this.translator.Anchor(()=> this.translator.t.BigFG(freeGameSymbolFGMessageSpanish.outerHTML, freeGameSymbolFGMessageEnglish.outerHTML)));

		let buttonContainer: HTMLElement = CreateElement("div", {classes:["buttonContainer"], parentToAppend:dialog, 
			style:
			{
				position:"absolute",
				bottom:  Scale.Ypx(-50),
				width:"100%",
				height:  Scale.Hpx(300),
				display: "flex",
				justifyContent: "center",
				alignItems: "center"
			}
		})
		
		let button: HTMLElement = CreateElement("div", {classes:["button"], parentToAppend:buttonContainer, 
			style:
			{
				width: Scale.Wpx(600),
				height: Scale.Hpx(300),
				fontSize: Scale.fhpx(100),
				display: "flex",
				justifyContent:"center",
				alignItems:"center",
				backgroundSize: "contain",
				backgroundPosition: "center",
				backgroundRepeat:"no-repeat",
				backgroundImage :resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["button", "image"])).CssBackground(),
			}
		});

		//button.appendChild(this.translator.Anchor(()=> this.translator.t.freegameExit));
		this.buttonExitCanvas = this.ButtonCanvasText();		
		this.SetTextCanvas(this.translator.t.freegameExit, this.buttonExitCanvas);
		button.appendChild(this.buttonExitCanvas.View());
		this.translator.SetOnLanguageChangedCallback(() => this.SetTextCanvas(this.translator.t.freegameExit, this.buttonExitCanvas));
		


		AddMouseDownListener(button, () => {
			if (this.stateMachine.State() == FreegameStates.FinalMessage) {		
				//this.CreateTransitionPixi();		
				//SHOW VIDEO TRANSITION				
				this.Spin();
			}
			else {
				Log.Error(this.logGroup, "Can't confirm intro message, current state: " + FreegameStates[this.stateMachine.State()] + ", required state: " + FreegameStates[FreegameStates.IntroMessage]);
			}
		});
	}

	// protected PrepareReelsContainer(resourceManager: IReadOnlyResourceManager):void
	// {
	// 	this.reelsContainer = CreateElement("div",{classes:["reelsContainer"], parentToAppend:this.view,
	// 		style:{
	// 			width:"100%",
	// 			height:"100%",
	// 			top:"0px",
	// 			position : "absolute",
	// 		}
	// 	})
	// }

	//Put Title Freegame in funcion to overwrite
	public TitleLoaded(resourceManager:ResourceManager)
	{		
		// this.titleSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("freegametitle")).sprite, canvasSize: new Size(1920, 400)});				
		// this.titleSprite.Update();
		// //this.titleSprite.canvas.view.style.zIndex = ""+ ZIndex.FreeGameIntroText;
		// this.titleSprite.canvas.view.style.position="absolute";
		// //this.titleSprite.canvas.view.style.top="1287px";
		// this.titleSprite.canvas.view.style.top="-873px";
		//this.view.appendChild(this.titleSprite.View());
	}

	
	

	protected async BasePrepare(resourceManager: IWriteOnlyResourceManager) {
		//resourceManager.Add(new HTMLResource(this.params.commonBonusResourcesBasePath +  "FreegameBonus.html", this.resid.ScopedResourceName("html")));
		//resourceManager.Add(new CSSResource(this.params.commonBonusResourcesBasePath +  "FreegameBonus.css", this.resid.ScopedResourceName("css"), this.resid.CSSScope()));

		this.PrepareFonts(resourceManager);
		this.BackgroundPrepare(resourceManager);

		
		resourceManager.Add(new DecodedImageResource(this.params.gameResourcesBasePath + "resources/dialog.png", this.resid.ScopedResourceName(["dialog", "image"])));
		resourceManager.Add(new DecodedImageResource(this.params.gameResourcesBasePath + "resources/button.png", this.resid.ScopedResourceName(["button", "image"])));		
		resourceManager.Add(new DecodedImageResource(this.params.commonBonusResourcesBasePath + "resources/ContainerText/STICKY-BONUS-END-TEXTS_ENGLISH.png", this.resid.ScopedResourceName(["end", "english"])));
		resourceManager.Add(new DecodedImageResource(this.params.commonBonusResourcesBasePath + "resources/ContainerText/STICKY-BONUS-INTRO-TEXT_ENGLISH.png", this.resid.ScopedResourceName(["intro", "english"])));

		resourceManager.Add(new DecodedImageResource(this.params.commonBonusResourcesBasePath + "resources/ContainerText/STICKY-IBONUS-END-TEXTS_SPANISH.png", this.resid.ScopedResourceName(["end", "spanish"])));
		resourceManager.Add(new DecodedImageResource(this.params.commonBonusResourcesBasePath + "resources/ContainerText/STICKY-IBONUS-NTRO-TEXTS_SPANISH.png", this.resid.ScopedResourceName(["intro", "spanish"])));
		await this.PrepareTransition(resourceManager);
	
	}

	//PREPARE TITLE FOR TRANSITION 
	public async PrepareTransition(resourceManager: IWriteOnlyResourceManager) {
		let transitionResources = {				
			audio: this.audio,				
			logGroup: this.logGroup,
			systemContext: this.systemContext,
			gameName: this.gameName,
			resid: this.resid,								
			fadeOut: true,								
			skelentonDataSpine : globalThis?.jackpotDisplayGlobal?.GetSpineSkeleton(),	
			transitionPIXITypeStyle : this.params.gameConfig.transitionPIXITypeStyle,	
			bonusCommonPath : this.params.commonBonusResourcesBasePath,
			bonusName: this.bonusName,
		};

		let transitionViewFactory: ITransitionFactoryPIXIAPP = new TransitionFactoryPIXIAPP();
		this.transitionView = await transitionViewFactory.CreatePIXIAPP(transitionResources);				
		await this.transitionView?.PrepareResources(resourceManager);			
		this.transitionView.onTransitionEnd = () => {
			this.OnTransitionEnded()
		}
		this.transitionView.onTransitionStart = () => {
			this.OnTransitionStarted()
		}
	}

	public async LoadTransition(resourceManager: IReadOnlyResourceManager) {
		await this.transitionView?.ResourcesLoaded(resourceManager);	
	}
	

	

	protected BackgroundPrepare(resourceManager: IWriteOnlyResourceManager)
	{
		if(Settings.Enable2plus1 == true ){			
		resourceManager.Add(new ImageResource(this.params.gameBonusResourcesBasePath +"background"+Settings.Screens+"S/"+"background2plus1.png", this.resid.ScopedResourceName(["background", "image"])));
		}else { 
			resourceManager.Add(new ImageResource(this.params.gameBonusResourcesBasePath +"background"+Settings.Screens+"S/"+"background.png", this.resid.ScopedResourceName(["background", "image"])));
		}
		//resourceManager.Add(new ImageResource(this.params.gameResourcesBasePath + "background.2.jpg", this.resid.ScopedResourceName(["background.2", "image"])));
		//resourceManager.Add(new ImageResource(this.params.gameResourcesBasePath + "background.3.jpg", this.resid.ScopedResourceName(["background.3", "image"])));
	}

	protected PrepareFonts(resourceManager: IWriteOnlyResourceManager): void {
	
		resourceManager.Add(new FontResource(this.params.commonBonusResourcesBasePath + "resources/newzone.ttf", this.resid.ScopedResourceName("bigwincount")));
		resourceManager.Add(new FontResource(this.params.gameBonusResourcesBasePath + "fontStyle.ttf", this.resid.ScopedResourceName(["lines", "font"])));
	}

	protected gameBackground: string = null;
	protected async BaseLoaded(resourceManager: IReadOnlyResourceManager)
	{
		let gameBackground = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["background", "image"]));
        this.gameBackground = gameBackground.CssBackground();

		this.backgroundFreeGameBonus.style.backgroundImage = this.gameBackground;		
		await this.LoadTransition(resourceManager);
		await this.LoadedResourcesBonusViewApp(resourceManager);
	}

	protected textureByLanguage : Record <keyof typeof translationMap , TextureDialogLanguage > = {
		romanian: {
			textureBonusIntro : null,
			textureBonusFinal : null,
		},
		spanish: {
			textureBonusIntro : null,
			textureBonusFinal : null,
		},
		english: {
			textureBonusIntro : null,
			textureBonusFinal : null,
		}
	}

	protected textureDialogBonus: PIXI.Texture<PIXI.Resource>;
	protected textureButtonBonus: PIXI.Texture<PIXI.Resource>;
	//protected textureIntroBonus: PIXI.Texture<PIXI.Resource> [] = [];
	//protected textureFinalBonus: PIXI.Texture<PIXI.Resource> [] = [];


	protected async LoadedResourcesBonusViewApp(resourceManager: IReadOnlyResourceManager){
		let dialogTexturesDecoded = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["dialog", "image"]));
        //dialogTextureBasePixi.scaleMode = PIXI.SCALE_MODES.NEAREST;
        this.textureDialogBonus = PIXI.Texture.from(dialogTexturesDecoded.DecodedImage());


		let buttonTexturesDecoded = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["button", "image"]));
        //buttonTextureBasePixi.scaleMode = PIXI.SCALE_MODES.NEAREST;
        this.textureButtonBonus = PIXI.Texture.from(buttonTexturesDecoded.DecodedImage());


		//create texture englis y rumano
		//intro
		let introEnglishTexturesDecoded = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["intro", "english"]));
        let intoEnglishTexture = PIXI.Texture.from(introEnglishTexturesDecoded.DecodedImage());
        //introEnglishTextureBasePixi.scaleMode = PIXI.SCALE_MODES.NEAREST;
        //this.textureIntroBonus.push(new PIXI.Texture(introEnglishTextureBasePixi));
		this.textureByLanguage.english.textureBonusIntro = intoEnglishTexture;


		//end
		let finalEnglishTexturesDecoded = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["end", "english"]));
        let finalEnglishTexture = PIXI.Texture.from(finalEnglishTexturesDecoded.DecodedImage());
        //introEnglishTextureBasePixi.scaleMode = PIXI.SCALE_MODES.NEAREST;
        //this.textureFinalBonus.push(new PIXI.Texture(finalEnglishTextureBasePixi));
		this.textureByLanguage.english.textureBonusFinal = finalEnglishTexture;



		// create testure spanish		
		//intro
		let introSpanishTexturesDecoded = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["intro", "spanish"]));
        let introSpanishTexture = PIXI.Texture.from(introSpanishTexturesDecoded.DecodedImage());
        //introSpanishTextureBasePixi.scaleMode = PIXI.SCALE_MODES.NEAREST;
        //this.textureIntroBonus.push(new PIXI.Texture(introSpanishTextureBasePixi));		
		this.textureByLanguage.spanish.textureBonusIntro = introSpanishTexture
		//end
		let finalSpanishTexturesDecoded = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["end", "spanish"]));
		let finalSpanishTexture = PIXI.Texture.from(finalSpanishTexturesDecoded.DecodedImage());
        //introSpanishTextureBasePixi.scaleMode = PIXI.SCALE_MODES.NEAREST;
        //this.textureFinalBonus.push(new PIXI.Texture(finalSpanishTextureBasePixi));
		this.textureByLanguage.spanish.textureBonusFinal = finalSpanishTexture;
	}

	// protected PicksPrepare(resourceManager: IWriteOnlyResourceManager): void 
	// {
	// 	resourceManager.Add(new SpriteResource(this.params.gameBonusResourcesBasePath + "pick", this.resid.Add("pick"), true, this.logGroup.Add("pick"), true));
	// }

	//protected PicksPositions(): FreegamePickElemGeometry[] {
	//	let geometry: FreegamePickElemGeometry[] = [];
	//
	//	let displayWidth: number = 540 * 0.75;
	//	let displayHeight: number = 510 * 0.75;

	//	let displayRects: PixelRect[] = [
	//		new PixelRect(21, 328, displayWidth, displayHeight),
	//		new PixelRect(363, 528, displayWidth, displayHeight),
	//		new PixelRect(705, 328, displayWidth, displayHeight),
	//		new PixelRect(1044, 528, displayWidth, displayHeight),
	//		new PixelRect(1386, 328, displayWidth, displayHeight),
	//	];

	//	// offset relative to pick rect
	//	let pickRect = new PixelRect(50, 50, displayWidth - 100, displayHeight - 100);
	//	let awardRect = new PixelRect(50, 50, displayWidth - 100, displayHeight - 100);

	//	for (let i = 0; i < displayRects.length; i++) {
	//		geometry.push(new FreegamePickElemGeometry(displayRects[i], pickRect, awardRect));
	//	}

	//	return geometry;
	//}

	protected canvasSprite: CanvasSprite = null;
	
	// protected PicksLoaded(resourceManager: IReadOnlyResourceManager): void {

	// 	let pickGeometries: FreegamePickElemGeometry[] = this.PicksPositions();
	// 	this.canvasSprite = null;

	// 	for (let i = 0; i < 5; i++) {

	// 		let sprite: Sprite = resourceManager.Get<SpriteResource>(this.resid.Add("pick")).sprite.Copy();
	// 		//let canvasSprite: CanvasSprite = new CanvasSprite(sprite, pickGeometries[i].displayRect.Size());
	// 		this.canvasSprite = new CanvasSprite(sprite, pickGeometries[i].displayRect.Size());

	// 		let params: FreegamePickElementParams = new FreegamePickElementParams(
	// 			i, 
	// 			this.logGroup,
	// 			pickGeometries[i].displayRect, 
	// 			pickGeometries[i].pickRect, 
	// 			pickGeometries[i].awardRect, 
	// 			this.canvasSprite
	// 		);

	// 		let pick: FreegamePickElement = this.params.pickElementFactory.CreatePickElement(params);

	// 		pick.AddPickCallback((index: number) => this.OnPicked(index));
	// 		pick.AddFreegamePickAwardDisplayedCallback((index: number) => this.OnAwardRevealed(index));
	// 		pick.AddRemainingDisplayedCallback((index: number) => this.OnRemainingRevealed(index));

	// 		pick.OnDisplayAwardCallback = () => this.audio.Play(this.resid.ScopedResourceName("pick"));
	// 		pick.OnDisplayRemainingCallback = () => this.audio.Replay(this.resid.ScopedResourceName("remaining"));

			
	// 		this.picks.push(pick);
	// 		this.picksContainer.appendChild(pick.View());
			
	// 	}
	// }

	//History view
	protected PrepareHistory(resourceManager: IWriteOnlyResourceManager)
	{
		//resourceManager.Add(new CSSResource(Settings.ResourcesFolder + "multigame/slot/common/resources/playLines.css",this.resid.ScopedResourceName("playLines"), this.resid.Add("History").CSSScope()));
	}

	protected historySpinableReels : SpinnableReels = null;
	protected LoadedHistory(resourceManager: IReadOnlyResourceManager)
	{
		this.historySpinableReels =  new SpinnableReels(this.params.windowSymbolSize, new Rect(0,0,Scale.W(720),Scale.H(512)), this.params.spinnableReelsParams);
		SetStyles(this.historySpinableReels.GetView(),
		{
			position:"static"
		})
	}


	/**
	 *	BIG WIN
	 */
	protected BigWinPrepare(resourceManager: IWriteOnlyResourceManager): void {


		// message
		// for (let i = 0; i < this.wins.length; i++) {
		// 	resourceManager.AddGlobal(new SpriteResource(Settings.ResourcesFolder + "multigame/slot/common/resources/winmessages/" + this.wins[i].file, ResourceIdentifier.Global.Add("winmsg").Add(this.wins[i].name), true, LogGroup.Global.Add("WinMsg").Add(this.wins[i].name), true));
		// }

		// fountain
		resourceManager.AddGlobal(new SpriteResource(Settings.ResourcesFolder + "multigame/slot/common/resources/coin_1_200x200", ResourceIdentifier.Global.Add("fountain").Add("coin"), true, LogGroup.Global.Add("fountain").Add("coin"), true));
	}

	protected BigWinLoaded(resourceManager: IReadOnlyResourceManager): void {
		//this.winMessageAnimation = new WinMessageAnimation(this.params.screenSize);
		this.shakeAnimation = new ShakeAnimation(this.spinnableReels.GetView());
		this.bigWinCountAnimation = new BigWinCountAnimationPIXIAPP(this.resid, new Size(Scale.W(1920), Scale.H(250)), 150,this.resid.ScopedResourceName("bigwincount"));

		// // messages
		// for (let i = 0; i < this.wins.length; i++) {
		// 	let message = new WinMessage(this.wins[i].name, resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("winmsg").Add(this.wins[i].name)).sprite.Copy(), this.wins[i].winMultiplier, this.audio.Track(this.resid.ScopedResourceName(this.wins[i].name)));
		// 	this.winMessageAnimation.AddMessage(message);
		// 	message = null;
		// }

		//this.view.appendChild(this.winMessageAnimation.View());


		// fountain
		let fountainAnimation = SlotGameType1Shared.Instance().smallFountainAnimation;
		fountainAnimation.AddOnStartCallback(this.resid, () => this.audio.PlayLoop(this.parentresid.ScopedResourceName("fountain")));
		fountainAnimation.AddOnStopCallback(this.resid, () => this.audio.Stop(this.parentresid.ScopedResourceName("fountain")));
		fountainAnimation = null;
	}

	/**
	 *	FEATURES
	 *  TODO check what features are actually enabled in freegames!
	 */
	protected async FeaturesPrepare(resourceManager: IWriteOnlyResourceManager): Promise<void> {

		// // EXPANDING WILD
		if (this.params.bonusConfiguration.FeatureConfigurations.find(f => f && f.FeatureType == "ExpandingWildBulk") ) {

			let params: ExpandingWildsBulkParam = {
				resid: this.resid,
				logGroup: this.logGroup,
				resourcesBasePath: this.basepath + "resources/expanding_wild_bulk/", 
				slotWindow: this.params.windowRectangle, 
				slotWindowSymbolSize: this.params.windowSymbolSize, 
				reelSetMapper: this.reelSetMapper, 
				audio: this.audio,
				gameName: this.gameName,
                availableSymbols: this.params.availableSymbols,
				systemContext: this.systemContext,
				symbolTypeAnim : this.params.gameConfig.symbolsType
            };
            
            let config: ExpandingWildsBulkConfig = this.params.bonusConfiguration.FeatureConfigurations.find(f => f && f.FeatureType == "ExpandingWildBulk")as unknown as ExpandingWildsBulkConfig;
			let expandingWildsBulk: ExpandingWildsBulkPIXIAPP = new ExpandingWildsBulkPIXIAPP(params, config);
			params = null;
			config = null;
			expandingWildsBulk.AddOnCompleteCallback(() => this.stateMachine.ChangeState(FreegameStates.BigWin));
			this.features.set("ExpandingWildBulk", expandingWildsBulk);
			expandingWildsBulk = null;
		}

		if (this.params.bonusConfiguration.FeatureConfigurations.find(f => f && f.FeatureType == "ExpandingWildReel") ) {
			let params: ExpandingWildsReelParam = {
				resid: this.resid,
				logGroup: this.logGroup,
				resourcesBasePath: this.params.gameResourcesBasePath + "resources/expanding_wild_reel/", 
				slotWindow: this.params.windowRectangle, 
				slotWindowSymbolSize: this.params.windowSymbolSize, 
				reelSetMapper: this.reelSetMapper, 
				audio: this.audio,
				gameName: this.gameName,
                availableSymbols: this.params.availableSymbols,
				systemContext: this.systemContext,
				symbolTypeAnim : this.params.gameConfig.symbolsType
            };

            let config: ExpandingWildReelConfiguration = this.params.bonusConfiguration.FeatureConfigurations.find(f => f && f.FeatureType == "ExpandingWildReel") as ExpandingWildReelConfiguration;
		    let expandingWildsReel: ExpandingWildsReelPIXIAPP = new ExpandingWildsReelPIXIAPP(params, config);
		    expandingWildsReel.AddOnCompleteCallback(() => this.stateMachine.ChangeState(FreegameStates.BigWin));
		    this.features.set("ExpandingWildReel", expandingWildsReel);
			config = null;
			expandingWildsReel = null;
			params = null;
		}
		


		for (let [name, feature] of this.features)
		{
			await feature.PrepareResources(resourceManager)
		}
		
		await this.plusOneAnim.PrepareResources(resourceManager);


		const scatterRandomAwardConfig = this.params.bonusConfiguration.FeatureConfigurations.find(f => f && f.FeatureType == "ScatterRandomAward") as ScatterRandomAwardConfiguration;
		if (scatterRandomAwardConfig)
		{
			let params: ScatterRandomAwardCreateParams =
			{
				logGroup: this.logGroup,
				resid: this.resid,
				// reelSet: this.params.bonusConfiguration.ReelSet,
				availableSymbols: this.params.availableSymbols
			};

			let config: Record<string, ScatterRandomAwardConfiguration> = {"ScatterRandomAward": scatterRandomAwardConfig}
			this.scatterRandomAwardFeature = new ScatterRandomAwardPIXI(params, config, this.params.color);
			await this.scatterRandomAwardFeature.PrepareResources(resourceManager);
			params = null;
			config = null;
			resourceManager = null;
		}
	}

	protected async FeaturesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {


		// // EXPANDING WILD
		for (let [name, feature] of this.features)
		{
			await feature.ResourcesLoaded(resourceManager);
			//this.view.appendChild(feature.View());
		};

		await this.plusOneAnim.ResourcesLoaded(resourceManager);
		//this.plusOneAnim.View().style.pointerEvents = "none"; // not clickable
		//this.plusOneAnim.View().style.zIndex = ZIndex.PlusOne.toString();
		//this.view.appendChild(this.plusOneAnim.View());

		if (this.scatterRandomAwardFeature)
		{
			await this.scatterRandomAwardFeature.ResourcesLoaded(resourceManager);
			this.scatterRandomAwardFeature.UpdateReels({
				playWindow: this.params.windowSymbolSize,
				reelSet: this.params.bonusConfiguration.ReelSet
			});
		}

		resourceManager = null;
	}

	/**
	 *	REELS
	 */
	public PrepareBackgroundReel(resourceManager: IWriteOnlyResourceManager)
	{
		this.spinnableReelsParams.backgroundImage=new DecodedImageResource(this.params.gameBonusResourcesBasePath + "reel.png", this.resid.ScopedResourceName(["reel","image"]));
		resourceManager.Add(this.spinnableReelsParams.backgroundImage);

		this.spinnableReelsParams.maskbackgroundImage = new DecodedImageResource(this.basepath + "resources/reelMask.png", this.resid.ScopedResourceName(["reelMask", "image"]));
		resourceManager.Add(this.spinnableReelsParams.maskbackgroundImage);		
	}

	protected handleLoadProgeres(loader, resource) {
		console.log(loader.progress + "% -FreeGameBonus-loaded");
	}
	
	// protected colorLineMarkers: MarkersInfoColors =
	// {
	// 	MarkerbackgroundColor: "linear-gradient(90deg, rgba(6,65,42,1) 0%, rgba(117,255,9,1) 35%, rgba(183,255,9,1) 55%, rgba(117,255,9,1) 75%, rgba(6,65,42,1) 100%), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
	// 	//linearColor:"linear-gradient(to left , transparent, LightGoldenrodYellow,transparent ) 0 10 100%",
	// };

	protected async PrepareWinLines(resourceManager: IWriteOnlyResourceManager)
	{
		// construct win lines
		let winLinesAnimParams: WinLinesAnimationParams =
		{
			viewSize: this.params.screenSize,
			spinnableReels: this.spinnableReels,
			lines: this.params.playlines,
			logGroup: this.logGroup,
			resid: this.resid,
			systemContext: this.systemContext,
			slotWindow : this.params.windowRectangle,
			slotWindowSymbolSize :this.spinnableReels.GetWindowSymbolSize(),
			colorLineMarkers : this.params.colorLineMarkers,
			speedFactorAnimation : this.params.winAnimationSpeedFactor,
			gameName : this.gameName,
			winLinesTypeStyle : this.params.gameConfig.winLinesTypeStyle,
		};

		// TODO replace with factory
		this.winLinesAnimation = new WinSquaresAnimationsSpinePIXIAPP(winLinesAnimParams);


		this.winLineMarkers = new WinLineMarkers(this.params.windowRectangle, this.spinnableReels.GetWindowSymbolSize(), this.params.playlines);

		this.winLinesAnimation.AddStartLineCallback((line: LineWin, color: Color) => 
		{
			this.audio.PlayLoop(this.parentresid.ScopedResourceName("linecount"));
			this.audio.PlayLoop(this.parentresid.ScopedResourceName("lineCountBackground"));
		});

		this.winLinesAnimation.AddNextLineCallback((line: LineWin, color: Color, animateOnlyWinningSymbols: boolean) => 
		{
			this.winLineMarkers.Show(line.LineIndex, color);
			this.panel.SetMessage(this.translator.t.linepay("" + (line.LineIndex +1), service.moneyFormatter.FormatCreditCurrentDenom(line.Win)));
			let symbolPositions:SymbolPositionToAnimate[] = [];
			let lineindex:number = line.LineIndex;

			let symbolsToAnimate: number = this.params.playlines[lineindex].length;
			if (animateOnlyWinningSymbols)
			{
				symbolsToAnimate = line.SymbolCount;
			}

			for(let i = 0; i < symbolsToAnimate; i++)
			{
				symbolPositions.push(new SymbolPositionToAnimate(i,this.params.windowSymbolSize.Height - 1 - this.params.playlines[lineindex][i]));
			}
			
			this.screenProtocol?.Send(new SlotGameMessages.WiningSymbol(line.SymbolIndex), this.screenProtocolScope);			
			this.symbolsAnimation.Stop();
			try {
				if (this.params.gameConfig.symbolsType == SymbolTypeAnim.Sprites) {
					this.spinnableReels.StopSymbolsAnim();
					this.spinnableReels.PlaySymbolsAnim(symbolPositions , true);
				}
				else if (this.params.gameConfig.symbolsType == SymbolTypeAnim.Spine) {
					this.params.symbolCollection.PlayAnimationWinSymbolSpineSymbol(symbolPositions);
				}
			} catch (error) {
				Log.Error(this.logGroup, "Error playanim symbol", error);
			}
			
			symbolPositions = null;
			symbolsToAnimate = null;
			lineindex = null;
		});

		this.winLinesAnimation.AddCompleteCallbacks(() => 
		{
			try {
				this.spinnableReels.StopSymbolsAnim();	
			} catch (error) {
				Log.Error(this.logGroup, "Error stopsanim symbol", error);
			}			
			this.winLineMarkers.Hide();		
			this.audio.Stop(this.parentresid.ScopedResourceName("linecount"));
			this.audio.Stop(this.parentresid.ScopedResourceName("lineCountBackground"));
			
			this.stateMachine.ChangeState(FreegameStates.Collect); 
			//this.DisableSymbolsAnimation();
			
		});

		await this.winLinesAnimation.PrepareResources(resourceManager);
		winLinesAnimParams = null;
		resourceManager = null;
		
	}


	protected anticipationStarted: boolean = false;
	protected ConstructReels(): void {

		this.spinnableReels = new SpinnableReelsBigCanvas(this.params.windowSymbolSize, this.params.windowRectangle, this.params.spinnableReelsParams , this.resid, this.systemContext);
	
		this.spinAnimation = new SpinAnimation(this.logGroup);
		this.reelSetMapper = new ReelSetMapper(this.params.windowSymbolSize, this.logGroup);

		//this.InitializeIsAnimation();
	}

	protected reelElement:  PIXI.Container[] = null;
	protected reelMask:  PIXI.Container[] = null;
	protected reelSpinAnimation : ReelSpinAnimation [] = [];
	protected LoadedReels(){

		for (let i: number = 0; i < this.spinnableReels.GetWindowSymbolSize().Width; i++) {
			((i: number) => {

				
				let isSpinEnding = false;				
				//console.log("reelElementReturned:",	this.reelElement[i]);				
				//console.log("reelElementReturned:",reelWhitBackgroundElement[i]);				
				//SetStyles(reelWindowElement., {margin: "0px 5px"});

				// const anticipationZoomFactor: number = 1.125;
				// const idleZIndex: number = ZIndex.ReelContainerBackground;
				// const anticipationZIndex: number = 100;


				//const anticipationBeginAnim = TweenLite.to(reelWhitBackgroundElement[i], 0.5, {pixi:{scaleY: anticipationZoomFactor, onStart: () =>this.reelElement[i].zIndex = anticipationZIndex}});
				//const anticipationEndAnim = TweenLite.to(reelWhitBackgroundElement[i], 0.5, {pixi:{scaleY: 1,onStart: () =>this.reelElement[i].zIndex = idleZIndex}});

				//let originalBackgroundAnticipation: Color = null;
				//let newBackgroundAnticipation: Color = null;

				let r: ReelSpinAnimation = new ReelSpinAnimation(
					i,
					this.logGroup,
					this.spinnableReels.GetSymbolSize(),
					this.spinnableReels.GetWindowSize(),
					this.spinnableReels.GetWindowSymbolSize(),
					this.spinnableReels.GetExtendendWindowSymbolSize(),
					1,
					0,
					400,
					0.90 * 0.30

				);

				this.reelSpinAnimation.push(r);

				let m: ReelMapper = new ReelMapper(i, this.logGroup, this.params.windowSymbolSize.Height, this.spinnableReels.GetExtendendWindowSymbolSize().Height);

				this.reelSetMapper.AddReelMapper(m);

				r.AddOnStartCallback(() => {
					this.DisableReelOverflow(i);		
					isSpinEnding = false;
					m.Start();													
					//this.bigSymbolAnim.UpdateSymbols(i, m.GetSymbols2().map(s => s.symbolIndex));
				});
 
				r.AddOnStopAvailableCallback((reelIndex) => {
					//// Log.Debug(this.logGroup, "Reel stop request is available");
				});

				r.OnUpdateCallback = (anim, params) => {

					//let roundToNPlaces: number = 3;
					// let distance = Math.round(r.GetDistance() * 1000)
					// let symbolHeight = Math.round(this.spinnableReels.GetSymbolSize().height * 1000);

					// let distanceInSymbols = Math.floor(distance / symbolHeight);
					// let translate = (distance % symbolHeight) / 1000;

					//// Log.Debug(this.logGroup, "Reel " + i + " symbol height: " + this.spinnableReels.GetSymbolSize().height + ", distance " + distance + ", in symbols, " + distanceInSymbols + ", translate y: " + translate);

					m.Update(params.distanceSymbols);

					// symbols in window have changed, update
					if (m.DidSymbolsChange()) 
					{
						
						
						this.RedrawReel(i);
						if (m.IsOverlayActivated() == true) {
							this.params.symbolCollection.CreateSymbolAnimation(i)
							this.AddAwardIntoSpine(i);
						};

						if (isSpinEnding)
						{
							//this.bigSymbolAnim.UpdateSymbols(i, newSymbols);
						}
					}

					if (this.reelElement?.[i]?.transform?.position)
                    {
                        this.reelElement[i].transform.position.y = params.translatePixels;
                    }
				};

				r.onAnticipationBeginCallbacks = () => {
					// Log.Debug(this.logGroup, "Anticipation begin");

					//anticipationBeginAnim.restart();
					this.anticipationAnimation?.ShowReelAnimation(i);
					if (!this.anticipationStarted) {
						//console.log(`Anticipation started reel ${i}`);
						this.anticipationStarted = true;
						this.audio.Play(this.resid.ScopedResourceName("anticipation"));
					}
				};

				r.onAnticipationEndCallbacks = () => {
					// Log.Debug(this.logGroup, "Anticipation end");

					//anticipationBeginAnim.pause();
					//anticipationEndAnim.restart();
				};

				r.AddOnDeccelerationCallbak((params: OnDeccelerationParams) => {
					// Log.Debug(this.logGroup, "decceleration started");

					// when decceleraton starts, we know when animation will end, so we can set up reel slice distance

					//let distance = r.GetDistance() + params.distanceToEnd;
					let distanceInSymbols = params.totalDistanceInSymbols; //Math.floor( / 100);

					m.Slice(distanceInSymbols);
					isSpinEnding = true;
					distanceInSymbols = null;
				});

                r.onNearComplete = this.OnReelNearStopped.bind(this);			

				this.spinAnimation.AddReelAnimation(r);

				r.AddOnCompleteCallback(() => this.OnReelStopped(i));
			})(i);
		}
		
		//Here
		this.spinAnimation.AddOnStartCallback(() => {
			//this.bigSymbolAnim.Stop();
		});

		this.spinAnimation.AddOnCompleteCallback(() =>this.SpinComplete());
		this.spinAnimation.AddOnCompleteCallback(() => {
			if (this.anticipationStarted == true) {
				this.fillingPotFeature?.EndAnticipationBegin();
			}
			this.anticipationStarted = false;
			this.audio.Stop(this.parentresid.ScopedResourceName("anticipation"));			
		});


		this.reelSetMapper.SetReelSet(this.params.bonusConfiguration.ReelSet, this.params.startPositions);
		this.currentSymbols = this.reelSetMapper.GetSymbols2();
		

		// redraw reels when context recovers
		this.spinnableReels.OnCreatedCallback = () => this.ReelsRestored();

		// redraw reels right away
		//this.ReelsRestored();
	}

	// protected DisableReelOverflow(reelIndex: number) {
	// 	try {
	// 		//show top symbols		
	// 		this.spinnableReels.symbolPIXISprite[reelIndex][this.spinnableReels.symbolPIXISprite[reelIndex].length - 1].visible = true;
	// 	} catch (error) {
	// 		Log.Error(this.logGroup, "Error disable overflow reel", error);
	// 	}
	// }

    protected RedrawReel(reelIndex: number): void
	{
		// 2 symbols more than window height 
		//	 - scrolling reveals additional symbol on top
		//	 - we don't want to change top symbol right at the top window line, 
		//     in case the top symbols peeks out a little
		this.currentSymbols[reelIndex] = this.reelSetMapper.GetReelMapper(reelIndex).GetSymbols2();

		for (let rowIndex: number = 0; rowIndex < this.currentSymbols[reelIndex].length; rowIndex++) {
			this.DrawSymbol(reelIndex, rowIndex);
		}
	}

	protected currentSymbols: ReelSymbolsToDisplay[][] = [];
	//protected EnableCache : Boolean = true;
	public DrawSymbol(reelIndex: number, rowIndex: number): void {
		try {
			
			let canvasPIXI: PIXI.AnimatedSprite = this.spinnableReels.symbolPIXISprite?.[reelIndex]?.[rowIndex];
			if (!canvasPIXI) {
				// no canvas to draw
				return;
			}

			if (this.params.gameConfig.symbolsType == SymbolTypeAnim.Spine) this.params.symbolCollection.DestroySymbol(reelIndex, rowIndex);
			let symbolToDisplay: ReelSymbolsToDisplay = this.currentSymbols[reelIndex][rowIndex];
			let symbol: SlotSymbol = this.params.availableSymbols[symbolToDisplay.symbolIndex];
			//canvas.renderable = true;
			let img = PIXI.Texture.from(this.params.symbolCollection.symbolCollectionMap.get("Symbol_" + symbol.ID).imgResource);
			//canvasPIXI.name = "Symbol_" + symbol.ID
			canvasPIXI.texture = img;
			const playWindow = this.params.initData.PlayWindow;
			const scalePercentage = this.params.gameConfig.symbolScale[`${playWindow.Width}x${playWindow.Height}`] == undefined ? 1 : this.params.gameConfig.symbolScale[`${playWindow.Width}x${playWindow.Height}`]
			//let scalePercentage = this.params.gameConfig.symbolScale[`${playWindow.Width}x${playWindow.Height}`] == undefined ? 1 : this.params.gameConfig.symbolScale[`${playWindow.Width}x${playWindow.Height}`] ;
		
			let scaleWidth = (this.spinnableReels?.GetSymbolSize().Width / img.width)* scalePercentage;
			let scaleHeight = (this.spinnableReels?.GetSymbolSize().Height / img.height) * scalePercentage
			let scaleProm = (scaleHeight + scaleWidth ) / 2;
			canvasPIXI.scale.set(scaleProm);
			canvasPIXI.visible = true;
			canvasPIXI.anchor.set(0.5);
			canvasPIXI.position.set(this.spinnableReels.GetSymbolSize().Width/2 , this.spinnableReels.GetSymbolSize().Height/2);
			this.scatterRandomAwardFeature?.DrawPIXI(reelIndex, symbolToDisplay.reelPositionIndex, rowIndex, symbol, canvasPIXI, null, this.params.symbolCollection.symbolCollectionMap.get("Symbol_" + symbol.ID).showAward);
			this.params.symbolCollection.SetSymbolCache("Symbol_" + symbol.ID, reelIndex, rowIndex, canvasPIXI);			
		}
		catch (ex) {
			//Log.Error(this.logGroup, "Error drawing symbol", ex);
		}
	}

//protected isSymbolAnimation : boolean [][] = [];
	//init symbol array animation
	// protected InitializeIsAnimation() {
	// 	for (let reel = 0; reel < this.spinnableReels.GetWindowSize().width; reel++) {
	// 		this.isSymbolAnimation.push([]);
	// 		for (let row = 0; row < this.spinnableReels.GetWindowSize().height; row++) {
	// 			this.isSymbolAnimation[reel][row] = false;
	// 		}			
	// 	}
	// 	//console.log("ArraySymbolsAnim:",this.isSymbolAnimation);
	// }

	// protected EnableSymbolsAnimation(positions: SymbolPositionToAnimate[]): void {
	// 	//console.log("ArraySymbolsAnimPositions:",positions);
	// 	//disable all symbols anim 
	// 	this.DisableSymbolsAnimation();
	// 	//only enable whe need anim 
	// 	for (let p of positions) {
	// 		this.isSymbolAnimation[p.reel][p.row] = true;
	// 		p = null;
	// 		//console.log("ArraySymbolsAnimPositions reel:",p.reel , "row:",p.row);
	// 	}
	// }

	//disable symbols anim 
	// protected DisableSymbolsAnimation(): void {
	// 	for (let reel = 0; reel < this.isSymbolAnimation.length; reel++) {
	// 		for (let row = 0; row < this.isSymbolAnimation[reel].length; row++) {
	// 			this.isSymbolAnimation[reel][row] = false; 
	// 		}
	// 	}
	// 	//console.log("ArraySymbolsAnim:",this.isSymbolAnimation);
	// }


	protected popoutAnimations: TweenLite[] = [];
	protected lastReelStoppedTime: number = 0;
	protected OnReelNearStopped(reelIndex: number) {
		this.anticipationAnimation?.HideReelAnimation(reelIndex);
		if (Timing.Timeouted(this.lastReelStoppedTime, 20)) {
			this.lastReelStoppedTime = Timing.Now();
			this.audio.Play(this.resid.ScopedResourceName("reelstop"), true);
		}		
	}


	public Confirm():void
	{
		
		if (this.stateMachine.State() == FreegameStates.NoPickIntro) {
			// Log.Debug(this.logGroup, "Intro message confirmed");
			this.stateMachine.ChangeState(FreegameStates.WaitFirstSpin);
		}
		else if (this.stateMachine.State() == FreegameStates.IntroMessage) {
			// Log.Debug(this.logGroup, "Intro message confirmed");
			this.stateMachine.ChangeState(FreegameStates.WaitFirstSpin);
		}
		// else if (this.stateMachine.State() == FreegameStates.PickedMessage) {
		// 	// Log.Debug(this.logGroup, "Intro message confirmed");
		// 	this.stateMachine.ChangeState(FreegameStates.WaitFirstSpin);
		// }
		else if (this.stateMachine.State() == (FreegameStates.FinalMessage)) {
			// Log.Debug(this.logGroup, "Final message confirmed");						
			this.ShowVideoTransition();	
		}
		else
		{
			Log.Error(this.logGroup, "Can't confirm message, current state: " + FreegameStates[this.stateMachine.State()]);
		}

	}
	public Spin(): void {

		// Log.Debug(this.logGroup, "Spin");

		switch (this.stateMachine.State()) {
			//case FreegameStates.Running:

			// when in idle state, spin starts new spin
			case FreegameStates.SpinIdle:
			case FreegameStates.WaitFirstSpin:
				
				// make sure to clear timer, to prevent double spin??
				if (this.session.left > 0) {

					// Log.Debug(this.logGroup, "Spin: Requesting next spin");

					if(this.jackpotSharedShow?.isVisible() == true && this.robotPlay.IsEnabled() == false) {					
						break;
					}

					if (this.autoSpinTimer != null) clearTimeout(this.autoSpinTimer);
					this.spinInterrupted = false;
					

					this.spinAnimation.Start();
					//debugger;
					
					// protocol.Send("BonusNextRun", null);
					this.stateMachine.ChangeState(FreegameStates.Spin);
			 	}
			break;
			// case FreegameStates.PickedMessage:
			case FreegameStates.FinalMessage:
			case FreegameStates.IntroMessage:			
				// Log.Debug(this.logGroup, "Spin: Confirming message");
				this.Confirm();
				break;
			case FreegameStates.NoPickIntro:
			 	// Log.Debug(this.logGroup, "Spin: Confirming message");
			 	this.Confirm();
				break;

			case FreegameStates.Spin:
				// Log.Debug(this.logGroup, "Spin: Request spin stop");
				this.spinAnimation.RequestStop(-1);
			break;

			case FreegameStates.Features:
				// Log.Debug(this.logGroup, "Spin: Request features stop");
				if(this.stateMachine.TimeSinceLastStateChange() > 1000){
					this.RequestFeatureStop();
				}				
			break;

			// When in win state, spin interrupts the count
			case FreegameStates.Win:
				// Log.Debug(this.logGroup, "Spin: Request win stop");
				this.spinInterrupted = true;
				this.winLinesAnimation.RequestStop();
			break;

			default:
				// Log.Debug(this.logGroup, "Spin: Nothing to do in current state: " + this.stateMachine.StateName);
			break;
		}
	}

	public AutoSpin(): void {
		// Log.Debug(this.logGroup, "Autospin");
		this.Spin();
	}

	// TODO change, remove, improve
	public Reset(): void {
		this.lastSpinResult = null;
	}

	protected OnReelStopped(reelIndex: number): void
	{		
		console.log("ReelStops:",reelIndex);
		this.params.symbolCollection.CreateSymbolAnimation(reelIndex);		
		this.AddAwardIntoSpine(reelIndex);
		
		this.EnableReelOverflow(reelIndex);
		this.ZoomInSymbols(reelIndex);		
	}

	protected AddAwardIntoSpine(reelIndex : number){
		if (this.params.gameConfig.symbolsType == SymbolTypeAnim.Spine) {
			let symbolsReel = this.reelSetMapper.GetReelMapper(reelIndex).GetSymbols2();
			for (let rowIndex = 0; rowIndex < symbolsReel.length; rowIndex++) {
				// //set spine textures
				this.scatterRandomAwardFeature?.DrawSpine(reelIndex, symbolsReel[rowIndex].reelPositionIndex, rowIndex, this.params.availableSymbols[symbolsReel[rowIndex].symbolIndex], this.spinnableReels.symbolPIXISprite[reelIndex][rowIndex], this.spinnableReels.GetSymbolSize());
			}
			//symbolsReel = null;
		}
	}

	protected ZoomInSymbols(reelIndex: number) {
		//if (!this.zoomedInSymbols) this.InitZoomedInSymbols();

		console.log("ZoomInSymbols:", this.simpleLastBonusAction)
		let triggerPositions = Object.values(this.simpleLastBonusAction?.Triggers ?? {}) // get all trigger results out from spin result
			.map(tr => tr.symbolsTriggered) // get all symbol positions for each trigger result (creates 2d array SymbolPosition[][])
			//.flat()	// flattens to 1d array SymbolPosition[]
			.reduce((acc, curr) => [...acc, ...curr], [])
			.filter(p => p.Reel == reelIndex); // filter only positions for this reel




		for (let position of triggerPositions) {

			// reverse rows?
			let rowIndex = this.params.windowSymbolSize.Height - position.Row - 1;
			//console.log(`ZoomInSymbols() reel: ${reelIndex} row: ${row}`); 
			try {

				this.params.symbolCollection.PlayAnimationReelStopSpineSymbol(reelIndex, rowIndex);


				if (this.reelElement?.[reelIndex])
					this.reelElement[reelIndex].mask = null;

				if (this.reelMask?.[reelIndex])
					this.reelMask[reelIndex].visible = false;

			} catch (error) {
				Log.Error(this.logGroup, "Error zoomin drawing symbol", error);
			}
			//this.reelMask[reelIndex].alpha = 0 ;		
		}
		triggerPositions = null;
	}

	protected ZoomOutSymbols(): void {			
		for (let reel = 0; reel < this.params.windowSymbolSize.Width; reel++) {
			for (let row = 0; row < this.params.windowSymbolSize.Height; row++) {
				try {					
					if (this.reelElement?.[reel])
						this.reelElement[reel].mask = this.reelMask[reel];

					if (this.reelMask?.[reel])
						this.reelMask[reel].visible = true;
				} catch (error) {
					//Log.Error(this.logGroup, "Error drawing symbol", error);
				}
			}
		}		
		//this.stopAllGroowSymbolsAnim();			
	}

	protected EnableReelOverflow(reelIndex: number) {
		try {
			//hide top symbols
			//let currentReelCanvases: PIXI.AnimatedSprite[] = this.spinnableReels.symbolPIXISprite[reelIndex];
			for (let i = 0; i < this.spinnableReels.numAdditionalRowsTop; i++) {
				this.spinnableReels.symbolContainerSprite[reelIndex][this.spinnableReels.symbolPIXISprite[reelIndex].length - 1].visible = false;
			}
		} catch (error) {
			//Log.Error(this.logGroup, "Error drawing symbol", error);
		}
	}

	protected DisableReelOverflow(reelIndex: number) {
		try {
			//show top symbols		
			this.spinnableReels.symbolContainerSprite[reelIndex][this.spinnableReels.symbolPIXISprite[reelIndex].length - 1].visible = true;
		} catch (error) {
			//Log.Error(this.logGroup, "Error drawing symbol", error);
		}
	}

	protected SpinComplete(): void {
		this.stateMachine.ChangeState(FreegameStates.FillingPot , null , ChangeStateType.NextTask);
	}

	public Start(): void {
		// Log.Debug(this.logGroup, "Bonus started");

		this.lastSpinResult = null;
		this.session.Reset();

		{
			this.session.awarded = this.simpleBonusConfig.SpinsStarted;
			this.session.left = this.simpleBonusConfig.SpinsStarted;
			this.session.played = 0;

			this.stateMachine.ChangeState(FreegameStates.IntroTransition);
		}

		this.Show();

		this.PanelRequired(true);

		this.audio.PlayLoop(this.resid.ScopedResourceName("background"));

		//this.startValueSpinsText.get("spinsRemaning"+this.startArray[0]).text = this.session.left;
		if(this.spinsStats != null) this.spinsStats.text = this.translator.t.bonusSpinsRemainingAndTotal(this.session.played, this.totalSpins);
		//this.startValueSpinsText.get("spinsRemaning"+this.startArray[1]).text = this.session.played;
	}


	public Show()
	{
		this.view.style.display = "block";
		this.PanelRequired(true);
		//console.log("Show free game");
	}

	public Hide()
	{
		this.view.style.display = "none";
		//console.log("Hide free game");
	}


	protected forceSymbolsUpdate: boolean = false;
	public Update(): void {
		
		this.spinAnimation.Update();
		//this.transition.Update();

		this.features.forEach((feature) => feature.Update());

		this.symbolsAnimation.Update();
		//this.winMessageAnimation.Update();
		this.shakeAnimation.Update();
		this.winLinesAnimation.Update();
		this.plusOneAnim.Update();

		//Update for transition sprite ;
		this.transitionView.Update();
		//this.RedrawCanvas();		
		this.fillingPotFeature?.Update();
		this.spinnableReels.Update();
	}

	
	public RedrawCanvas(){
		if (this.buttonStartCanvas.WasContextLost() ) {
			this.SetTextCanvas(this.translator.t.freegameStart, this.buttonStartCanvas);			
		}
		if (this.buttonExitCanvas.WasContextLost() ) {
			this.SetTextCanvas(this.translator.t.freegameStart, this.buttonExitCanvas);			
		}
	}

	public View(): HTMLElement {
		return this.view;
	}

	public GetSession(): GameSession {
		return this.session;
	}

	/**
	 *	Internal states
	**/
	// protected HideAllContainers(): void {
	// 	this.containers.forEach((container, key) => container.style.display = "none");
	// }

	// protected ShowContainer(container: FreegameBonusContainer): void {
	// 	// Log.Debug(this.logGroup, "Showing container " + FreegameBonusContainer[container]);

	// 	let htmlElement = this.containers.get(container);
	// 	if (htmlElement != null)
	// 	{
	// 		htmlElement.style.display = "block";
	// 	}
	// 	else
	// 	{
	// 		Log.Error(this.logGroup, "Container does not exist: " + FreegameBonusContainer[container]);
	// 	}
	// }

	protected started:boolean=false;
	public ShowVideoTransition(): void{
		if(this.started == false){
			this.params.symbolCollection.DestroyAllSymbols();
			this.transitionView.ShowTransiton();
			//this.systemContext.SharedTransitionContext().GetTransition(this.resid.Add(this.bonusName + "-Transition-" + Settings.Screens))
			this.started = true;
		}		
	}

	protected OnTransitionStarted(){	
		// play transition audio
		this.audio.Play(this.resid.ScopedResourceName("transitionaudio"));	
		this.started = true;	
	}

	protected OnTransitionEnded(): void {
		// Log.Debug(this.logGroup, "Transition ended");
		this.started = false;
		if (this.stateMachine.State() == FreegameStates.FinalMessage) {
			this.stateMachine.ChangeState(FreegameStates.Idle);
		} else {
			this.stateMachine.ChangeState(FreegameStates.NoPickIntro);
		}
	}

	protected OnIntroTransitionBegin(): void
    {	
	this.OnNoPickIntroMessageBegin()
    }

    protected OnIntroTransitionEnd(): void
    {
		//this.OnTransitionEnded();
    }

	protected OnIntroMessageBegin(): void {
		//this.HideAllContainers();		
		//this.ShowContainer(FreegameBonusContainer.IntroMessage);
		this.robotPlay.BonusConfirm("IntroMessage");
	}

	protected OnIntroMessageEnd(): void {		
		this.robotPlay.BonusConfirmAccepted();
	}

	
	//protected triggerStartSoundLoop: ITimeout;
	//protected introStartSound: ITimeout;
	public override TriggerAnimationStartedSprite(loop : number , delay : number = 1000): void {		
		//let delay: number = 1000;
		for (let i = 0; i < loop; i++) {
			setTimeout(() => this.audio.Play(this.resid.ScopedResourceName("triggered")), delay * (i + 1));
		}
	}

	public override TriggerAnimationStartedSpine(): void {		
		this.audio.Play(this.resid.ScopedResourceName("triggered"));		
	}

	
	public override BackGroundTransition(): void {		
		this.audio.Play(this.resid.ScopedResourceName("intro"));				
	}

	public OnNoPickIntroMessageBegin():void
	{
		//this.HideAllContainers();
		//this.noPickintroMessageContainer.querySelector(".numPickedFreegames").innerHTML = "" + this.session.awarded;
		//this.ShowContainer(FreegameBonusContainer.Reels);
		//this.ShowContainer(FreegameBonusContainer.NoPickIntro);
		this.messageContainerPIXIAPP.visible = true;
		this.introMessageContainerPIXIAPP.visible = true;
		this.introMessageContainerPIXIAPP.interactive = true;
		this.introMessageContainerPIXIAPP.interactiveChildren = true;
		//this.screenProtocol?.Send(new FreegameMessages.PickMessage(this.session), this.screenProtocolScope);
		this.robotPlay.BonusConfirm("PickedMessage");
	}

	protected OnNoPickedMessageEnd(): void {
		//this.HideAllContainers();
		//this.ShowContainer(FreegameBonusContainer.Reels);
		this.robotPlay.BonusConfirmAccepted();
	}
	
	
	protected OnWaitFirstSpinBegin(): void {
		this.PanelRequired(true);
		this.messageContainerPIXIAPP.visible = false;
		this.introMessageContainerPIXIAPP.visible = false;
		this.timeoutAutoSpinFreeGames.Start();
	}
	//change type because need add some feature for 1 screen game 
	protected OnSpinBegin(): void {
		this.session.left--;
		this.session.played++;
		this.audio.Play(this.parentresid.ScopedResourceName("leverpull"));
		//this.screenProtocol?.Send(new FreegameMessages.SpinMessage(this.session), this.screenProtocolScope);
		//this.startValueSpinsText.get("spinsRemaning"+this.startArray[0]).text = this.session.left;
		//this.startValueSpinsText.get("spinsRemaning"+this.startArray[1]).text = this.session.played;
		if(this.spinsStats != null) this.spinsStats.text = this.translator.t.bonusSpinsRemainingAndTotal(this.session.played, this.totalSpins);
		this.OnBonusRunResult();		
	}

	protected OnSpinEnd(): void {
		this.audio.Stop(this.parentresid.ScopedResourceName("leverpull"));
	}

	protected featuresTimer: number = -1;
	protected currentFeature: SlotFeature = null;	
	protected currentBonus: SlotBonus = null;
	

	protected OnFeaturesFillingPot() {
		//let timeout = 0;				
			let ScatterRandomAward = (this.simpleLastBonusAction.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult)
			if (ScatterRandomAward?.ScattersPositionThisSpin.length > 0 && Settings.fillingPotFeature != FillingPotFeature.Disable) {				
				this.fillingPotNextTask?.Start();	

				this.fillingPotFeature?.StartIncrement({
					BonusWin: false,
					ScatterCordinates: (this.simpleLastBonusAction.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult)?.ScattersPositionThisSpin,
					winSymbols : this.simpleLastBonusAction.SpinWithFeatures.ExpectedSymbols
					
				});
	
				//Set Animation 
				let bonusTriggerSymbols: SymbolPositionToAnimate[] = [];
				let scatterPosition = (this.simpleLastBonusAction.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult)?.ScattersPositionThisSpin;
				scatterPosition.forEach(s => {
					bonusTriggerSymbols.push(new SymbolPositionToAnimate(
						s.Reel,
						//this.windowSymbolSize.height - symbolsTriggered[i].Row -1
						this.params.windowSymbolSize.Height - s.Row - 1
					));
				})

				//let symbols: SlotSymbol[] = [];
				let symbolA = this.simpleLastBonusAction.SpinWithFeatures.ExpectedSymbols.flat().filter(s => s.includes("SRA"));
				let symbolsConverted = this.params.availableSymbols.filter(s => symbolA.filter(s2 => s2 == s.ID) && s.ID.includes("SRA"));
				console.log("SRAWin:", symbolA);
				console.log("SRAWin:", symbolsConverted);
				let bonusData = this.params.initData.BonusTriggers.find(b => b.RequiredSymbols.find(rS => symbolsConverted.find(s => s.Index == rS)))

				console.log("SRAWin:", bonusData);

				let bonusReelStops : SlotBonus;
				if (bonusData != null) bonusReelStops = this.bonusList.get(bonusData.BonusName as Bonus) as SlotBonus;
				// console.log("SRAWin-Bonus:", bonusFind);

				if (this.params.gameConfig.symbolsType == SymbolTypeAnim.Sprites) {
					this.spinnableReels.StopSymbolsAnim();
					bonusReelStops?.TriggerAnimationStartedSprite(1 , 0);
					this.spinnableReels.PlaySymbolsAnim(bonusTriggerSymbols, false);
				}
				else if (this.params.gameConfig.symbolsType == SymbolTypeAnim.Spine) {
					bonusReelStops?.TriggerAnimationStartedSpine();
					this.params.symbolCollection.PlayAnimationWinSymbolSpineSymbol(bonusTriggerSymbols, false);
				}	
			}					
		else {
			this.stateMachine.ChangeState(FreegameStates.Features, null);
		}
	}


	protected OnFeaturesBegin() {
		let timeout = 1000;		
		// if (Settings.fillingPotFeature != FillingPotFeature.Disable) {
		// 	let ScatterRandomAward = (this.simpleLastBonusAction.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult)
		// 	if (ScatterRandomAward?.ScattersPositionThisSpin.length > 0) {
		// 		//timeout += 500;
		// 		this.fillingPotUpdate?.Start();		
		// 	}
		// 	this.fillingPotUpdate?.Start();
		// }			


		//setTimeout(()=>{
			// if (this.currentBonus != null)
			// 	{
			// 		// Log.Debug(this.logGroup, "Symbol trigger feature");
			// 		this.panel.SetMessage(this.translator.t.message_bonustriggered);
			// 		try {
			// 			if (this.params.gameConfig.symbolsType == SymbolTypeAnim.Sprites) {
			// 				this.currentBonus.TriggerAnimationStartedSprite();
			// 				this.spinnableReels.StopSymbolsAnim();
			// 				this.spinnableReels.PlaySymbolsAnim(this.bonusTriggerSymbols);
			// 			}
			// 			else if (this.params.gameConfig.symbolsType == SymbolTypeAnim.Spine) {	
			// 				this.currentBonus.TriggerAnimationStartedSpine();
			// 				this.params.symbolCollection.PlayAnimationWinSymbolSpineSymbol(this.bonusTriggerSymbols, false);
			// 			}
						
			// 		} catch (error) {
			// 			Log.Error(this.logGroup, "Error play symbol", error);
			// 		}
		
			// 		timeout += 1000;
					
			// 		this.timeoutStopsAnim.Start();		
			// 	}
				
				// prepare current feature
				this.currentFeature = null;
				//let delay: number = timeout;
				if (this.simpleLastBonusAction.SpinWithFeatures.FeatureResults["ExpandingWildBulk"]?.FeatureTriggered && this.simpleLastBonusAction.Win.ResultLines.length > 0){
					this.currentFeature = this.features.get("ExpandingWildBulk");
					this.currentFeature.Prepare(this.simpleLastBonusAction.SpinWithFeatures.FeatureResults["ExpandingWildBulk"])
				}
				else if (this.simpleLastBonusAction.SpinWithFeatures.FeatureResults["ExpandingWildReel"]?.FeatureTriggered && this.simpleLastBonusAction.Win.ResultLines.length > 0){			
						this.currentFeature = this.features.get("ExpandingWildReel");
						this.currentFeature.Prepare(this.simpleLastBonusAction.SpinWithFeatures.FeatureResults["ExpandingWildReel"]);
				}	
					
				if (this.simpleLastBonusAction.SpinWithFeatures.FeatureResults["PlusOneFeature"] && this.plusOneAnim.WillStartAnim() == true) {			
					// //check if some plus one need to create 
					//timeout += this.plusOneAnim.Duration();
					this.OnPlusOneTriggeBegin();
				} else {			
					//you dont hit some plus one , only its missing check if you hit some feature 
					// start feature with delay, or continue to next state
					this.featuresTimer = window.setTimeout(() => {
						if (this.currentFeature != null) {
							this.currentFeature.Start();
							this.robotPlay.OnSpinStopAvailable();
						}
						else {
							// no "known" features, continue to next state
							this.stateMachine.ChangeState(FreegameStates.BigWin);
						}
						this.featuresTimer = -1;
						//this.stateMachine.ChangeState(SlotGameState.Scatter);
					}, timeout);
				}
		//},1500);
		

		//his.stateMachine.ChangeState(SlotGameState.BigWin);
	}


	//Start plusone Anim 
	protected plusoneSymbolsPosition: PlusOneFeatureResult = null;
	protected OnPlusOneTriggeBegin() {	
		//debugger						
			this.plusoneSymbolsPosition = this.simpleLastBonusAction.SpinWithFeatures.FeatureResults["PlusOneFeature"] as unknown as PlusOneFeatureResult;	
			this.currentIndexPlusOneTrigger = 0;	
			this.PlayNextPlusOne();	
			//this.CheckifMorePlusOneExist(timeout);
	}

	//Check if are more plusone to trigger for anim 
	protected CheckifMorePlusOneExist(): void {
		this.currentIndexPlusOneTrigger++;		
		if (this.plusoneSymbolsPosition.SymbolPositions[this.currentIndexPlusOneTrigger] != null && this.plusOneAnim.WillStartAnim() == true) {			
			this.PlayNextPlusOne();	
		} else {			
			this.featuresTimer = window.setTimeout(() => {
				if (this.currentFeature != null) {
					this.currentFeature.Start();
					this.robotPlay.OnSpinStopAvailable();
				}
				else {
					// no "known" features, continue to next state
					this.stateMachine.ChangeState(FreegameStates.BigWin);
				}
				this.featuresTimer = -1;
				//this.stateMachine.ChangeState(SlotGameState.Scatter);
			}, 500);
		}
	};
	
	protected currentIndexPlusOneTrigger: number = 0;
	//show anim plus oone 
	protected PlayNextPlusOne() {
		let timeout = 0;
		this.plusOneAnim.StartPlusOnePIXIAPP(this.plusoneSymbolsPosition.SymbolPositions[this.currentIndexPlusOneTrigger], new Point(this.plusOneTarget.x, this.plusOneTarget.y));
		this.audio.Play(this.resid.ScopedResourceName("plusone"));
		setTimeout(() => {
			this.audio.Play(this.resid.ScopedResourceName("plusonemove"))
		}, 1500);
		timeout += this.plusOneAnim.Duration();

		// refresh top screen
		setTimeout(() => {
			//this.screenProtocol?.Send(new FreegameMessages.PlusMessage(this.session), this.screenProtocolScope)
			this.ApplySession(this.session);
			//this.startValueSpinsText.get("spinsRemaning" + this.startArray[0]).text = this.session.left += 1;
			this.session.left += 1;
			if(this.spinsStats != null) this.spinsStats.text = this.translator.t.bonusSpinsRemainingAndTotal(this.session.played , this.totalSpins+= 1);
			
			this.CheckifMorePlusOneExist();
		}, timeout);
	};


	//Create For Update The Session For 1 Screen Game
	protected ApplySession( session:FreegameSession): void
	{
		//TODO
	}

	protected RequestFeatureStop(): void
	{
		if (this.currentFeature != null)
		{
			this.currentFeature.RequestStop();
			this.symbolsAnimation.Stop()
			this.symbolsAnimation.Update();
			
		}
	}

	protected OnFeaturesEnd(): void
	{
		this.currentFeature = null;
	}

	protected OnBigWinBegin(): void {

		let winCredit: number = service.moneyFormatter.CentsToCredit(this.simpleLastBonusAction.Win.TotalWin);

		if (this.winMessageAnimation.WillTrigger(this.bet, winCredit)) {
			winCredit = null;
			this.shakeAnimation.Start();
			this.audio.Play(this.parentresid.ScopedResourceName("bigwin"));
			this.timeoutFreeGameWin.Start();
		}
		else {
			// Log.Debug(this.logGroup, "Big win message will not show");
			this.stateMachine.ChangeState(FreegameStates.Win);
		}
	}

	protected OnBigWinEnd(): void {
		let winCredit: number = service.moneyFormatter.CentsToCredit(this.simpleLastBonusAction.Win.TotalWin);

		if (this.winMessageAnimation.WillTrigger(this.bet, winCredit)) {
			this.winMessageAnimation.Start(this.bet, winCredit);
			this.fillingPotFeature?.OnStartBigWinShow();
			winCredit = null;
			this.bigWinCountAnimation.ViewPIXIAPP().visible = true;
			SlotGameType1Shared.Instance().smallFountainAnimation.Start(this.resid);
		}
	}

	protected OnWinBegin(): void {	
			
		if (this.simpleLastBonusAction.Win.TotalWin.InCents > 0)
		{

			let fixedDuration: number;
				fixedDuration = this.winLinesAnimFactor;		
				
			let duration:number = 0;
			if(this.simpleLastBonusAction.Win.ResultLines.length <= 10)
			{
				duration = this.audio.Track(this.parentresid.ScopedResourceName("linecount")).Duration() * 3 * 1000;
				if(duration == 0 ){
					//console.log("LineCount <= 10");
					duration =fixedDuration;
				}
			}

			else if(this.simpleLastBonusAction.Win.ResultLines.length >= 11 && this.simpleLastBonusAction.Win.ResultLines.length <= 50)
			{
				duration = this.audio.Track(this.parentresid.ScopedResourceName("linecount")).Duration() * 2 * 1000;
				if(duration == 0 ){
					//console.log("LineCount >= 11 && LineCount <= 50");
					duration = fixedDuration;
				}
			}
			else if(this.simpleLastBonusAction.Win.ResultLines.length >= 51)
			{
				duration = this.audio.Track(this.parentresid.ScopedResourceName("linecount")).Duration() * 1 * 1000;
				if(duration == 0 ){
					//console.log("LineCount >= 51");
					duration = fixedDuration;
				}
			}

			
			this.winLinesAnimation.Start(this.simpleLastBonusAction.Win.ResultLines, duration);
			
			this.session.totalWin = this.simpleLastBonusAction.WinSinceGameStart.TotalWin.InCents;
			this.session.winDuration = this.winLinesAnimation.GetDuration()/1000;
			this.screenProtocol?.Send(new FreegameMessages.WinMessage(this.session),this.screenProtocolScope);			
			this.winCreditAnimation = TweenMax.fromTo(this.winValues,
			this.winLinesAnimation.GetDuration()/1000,
			{win:this.params.clientState.PreviousWin},
			{win:this.params.clientState.Win, roundProps:"balance,win", 
				onUpdate: ()=>
				{
					this.bigWinCountAnimation.Display(service.moneyFormatter.CentsToCredit(this.winValues.win));
					this.panel.SetWin(service.moneyFormatter.FormatCreditCurrentDenom(this.winValues.win ), service.moneyFormatter.FormatCurrency(this.winValues.win));
					
					//this.panel.SetBalance(this.moneyFormatter.FormatCredit(this.winValues.balance), this.moneyFormatter.FormatCurrency(this.winValues.balance));
				},
				onComplete:()=>{
					//this.EnableCache = true;
				}
			});

			this.robotPlay.BonusRunStopAvailable();
		}
		else 	
		{
			this.stateMachine.ChangeState(FreegameStates.Collect);
			
		}
	}

	protected OnWinEnd(): void {
		// fast forward win count, if needed
		if (this.winCreditAnimation != null && this.winCreditAnimation.progress() != 1) {
			this.winCreditAnimation.progress(1, false);
		}

		this.symbolsAnimation.Stop();		
		this.winMessageAnimation.Stop();
		this.fillingPotFeature?.OnEndBigWinShow();
		SlotGameType1Shared.Instance().smallFountainAnimation.RequestStop(this.resid);
		this.bigWinCountAnimation.ViewPIXIAPP().visible = false;		
	}

	protected OnCollectBegin(): void {
		this.stateMachine.ChangeState(FreegameStates.Bonus);
		//this.screenProtocol?.Send(new FreegameMessages.WinInterruptedMessage(), this.screenProtocolScope);
		this.panel.SetMessage(this.translator.t.goodluck);
	}

	protected nextBonusData: ISimpleBonusAction[] = [];
	protected OnBonusBegin(): void {
		let currentindexData = this.simpleAllBonusSpinResult.findIndex((b) => b == this.simpleLastBonusAction);
		this.nextBonusData = this.simpleAllBonusSpinResult.filter((b, index) => index > currentindexData);


		//reste Bonus level if you hit some bonus 
		let bonusStartData = this.nextBonusData.find(b => b.Phase == "Start") as SpinAndHoldStartAction;
		//let bonusStartData = nextBonusData.find((b, index) => index == indexStartConfig);
		if (bonusStartData == this.simpleAllBonusSpinResult[currentindexData + 1]) {
			let bonusName = bonusStartData.Bonus as Bonus;
			//debugger
			if (bonusName) this.fillingPotFeature?.StartBonusWin(bonusName, bonusStartData.Types , bonusStartData.Multiplier);
			
			
		}

		bonusStartData = null;

		if (this.nextBonusData[0].Phase == "Start") {
				currentindexData = null;			
			this.timeoutShowBonusIntoBonus.Start();
		}
		else {
			this.stateMachine.ChangeState(FreegameStates.SpinIdle);
		}
	}

	public NextBonusEnd()
	{
		if(this.currentBonus != null)
		{
			this.panel.SetWin(service.moneyFormatter.FormatCreditCurrentDenom(this.params.clientState.Win), service.moneyFormatter.FormatCurrency(this.params.clientState.Win));
			this.stateMachine.ChangeState(FreegameStates.SpinIdle);
		}
		else
		{
			Log.Error(this.logGroup, "no next bonus");
		}
	}

	protected OnBonusEnd(): void {
		if (this.currentBonus) {
			this.currentBonus = null;
			this.audio.PlayLoop(this.resid.ScopedResourceName("background"));
		}
		this.fillingPotFeature?.RestartAnim();		
	}

	protected OnSpinIdleBegin(): void {

		this.panel.SetMessage("");

		this.spinnableReels.StopSymbolsAnim();

		//this.freegamesLeft.innerHTML = "Free games Left "+ this.session.left;
		//this.freegamesPlayed.innerHTML ="Free games Played "+ this.session.played;
		

		if (this.session.left > 0) {
			this.lastSpinResult = null;			
			this.simpleBonusConfig = null;
			// put some delay before next spin
			if (this.spinInterrupted) {
				this.AutoSpin();
			}
			else {
				this.panel.Start();
				
				this.autoSpinTimer = window.setTimeout(() => this.AutoSpin(), 500);
				//this.autoSpinTimer.Start();
			}
		}
		else {
			this.CreateTransitionPixi();
			// put some delay before final message			
			this.timeoutFreeGameFinalMessage.Start();
		}
	}

	protected OnSpinIdleEnd(): void {
		this.panel.Stop();
		this.ZoomOutSymbols();
	}

	protected OnFinalMessageBegin(): void {
		this.CreateTransitionPixi(this.gameViewApp);		
		this.audio.PlayLoop(this.resid.ScopedResourceName("final"));
		this.audio.Stop(this.resid.ScopedResourceName("background"));
		this.messageContainerPIXIAPP.visible = true;

		let spinEndAction = this.simpleAllBonusSpinResult.find(b=>b.Phase == "End" && b.Bonus == this.bonusName);
		this.session.totalWin = spinEndAction.WinSinceGameStart.TotalWin.InCents;
		spinEndAction = null;
		this.containerValueWinAwardText.text = service.moneyFormatter.FormatCurrency(this.session.totalWin);
		this.finalMessageContainerPIXIAPP.visible = true;
		this.finalMessageContainerPIXIAPP.interactiveChildren = true;	
		this.finalMessageContainerPIXIAPP.interactive = true;	






		this.PanelRequired(true);

		//this.HideAllContainers();

        // FIXME no query selector
		//this.finalMessageContainer.querySelector(".bonusCredits").innerHTML = this.moneyFormatter.FormatCreditCurrentDenom(this.lastSpinResult.TotalWin)

		//this.ShowContainer(FreegameBonusContainer.FinalMessage);
		//this.transition.Start();
		this.VoicePlay=true;
		//SHOW VIDEO TRANSITION
		//this.ShowVideoTransition();

	

		
		this.robotPlay.BonusConfirm("FinalMessage");
	
		//this.screenProtocol?.Send(new FreegameMessages.ShowWinContainer(this.session), this.screenProtocolScope);
	}

	protected OnFinalMessageEnd(): void {
		//this.ShowVideoTransition();
		//this.screenProtocol?.Send(new FreegameMessages.ResetFinalContainerWin(this.session), this.screenProtocolScope);		
		this.audio.Stop(this.resid.ScopedResourceName("background"));
		this.audio.Stop(this.resid.ScopedResourceName("final"));
		this.audio.Play(this.resid.ScopedResourceName("backgroundend"));
		this.OnBonusFinished();
		//this.transition.Start();
		this.robotPlay.BonusConfirmAccepted();
		this.VoicePlay=true;		
	}

	/**
	 *	External messages
	**/

	protected bonusTriggerSymbols: SymbolPositionToAnimate[] = [];
	public spinIndexData: number = 0;
	protected simpleLastBonusAction : FreegamesSpinAction;
	protected simpleAllBonusSpinResult: ISimpleBonusAction [] = null;
	public OnBonusRunResult(): void {

		//// Log.Debug(this.logGroup, "OnBonusRunResult(runResult: " + JSON.stringify(runResult) + ")");

		this.fillingPotFeature?.UpdateSpin();
		
		this.spinIndexData++;
		this.simpleLastBonusAction = this.simpleBonusSpin[this.spinIndexData];
		//this.lastSpinResult = fgRunResult;

		// this.session.left= this.simpleLastBonusAction.SpinsRemaining;
		this.session.played = this.simpleLastBonusAction.SpinsPlayed;		


		
		//update clienStat win the last win 
		this.params.clientState.SetWin(this.simpleLastBonusAction.WinSinceGameStart.TotalWin.InCents, "BigSymbolFreegames run result");
		
		

		//this.freegamesLeft.innerHTML = "Free games Left "+ this.session.left;
		//this.freegamesPlayed.innerHTML ="Free games Played "+ this.session.played;

		let targets: SpinTargetParams[] = [];
		for (let i = 0; i <this.simpleLastBonusAction.SpinWithFeatures.ReelStops.length; i++) {
			// anticipation can't be on the first reel
            let t: SpinTargetParams = {
                position: this.simpleLastBonusAction.SpinWithFeatures.ReelStops[i],
                anticipation: this.simpleLastBonusAction.Anticipation >= 0 && i >= this.simpleLastBonusAction.Anticipation,
                firstAnticipationReelIndex: this.simpleLastBonusAction.Anticipation,
            };
			targets.push(t);
			t = null;
		}
		
				this.bonusTriggerSymbols = [];
				if(this.simpleLastBonusAction.Triggers != null)
				{
					Object.entries(this.simpleLastBonusAction.Triggers);
					for(let [name,triggerResult] of Object.entries(this.simpleLastBonusAction.Triggers))
					{
						if((triggerResult as SimpleTriggerResult).symbolsTriggered != null)
						{
							let symbolsTriggered:SymbolPosition [] = (triggerResult as SimpleTriggerResult).symbolsTriggered;
							for(let i = 0; i < symbolsTriggered.length; i++)
							{
								this.bonusTriggerSymbols.push(new SymbolPositionToAnimate(
									symbolsTriggered[i].Reel,
									this.params.windowSymbolSize.Height - symbolsTriggered[i].Row -1
								));
							}
						}
						
					} 
				}
		

		// if(fgRunResult.Bonus != null)
		// {
		// 	this.currentBonus = this.bonusList.get(fgRunResult.Bonus);
		// }

		/* for (let i = 0 ; i < fgRunResult.ReelStops.length; i++)
		{
			targets.push(new SpinTargetParams(fgRunResult.ReelStops[i], false));
		} */

		this.spinAnimation.SetTargets(targets);
		this.reelSetMapper.SetTargets(targets);

		let scatterData =this.simpleLastBonusAction.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as unknown as ScatterRandomAwardResults;
		if(scatterData ){		
			this.scatterRandomAwardFeature?.SetAwards(scatterData.ScattersPositionThisSpin);
			//this.fillingPotUpdate?.Start();			
		}

		if (this.simpleLastBonusAction.Triggers.find(b => b.WillTrigger == true)) {
			let currentindexData = this.simpleAllBonusSpinResult.findIndex((b) => b == this.simpleLastBonusAction);
			let nextBonusData = this.simpleAllBonusSpinResult.find((b, index) => index > currentindexData);
			//let BonusName = this.simpleAllBonusSpinResult.filter(bonus => bonus.Phase == "Start" && bonus.Depth == 1);

			//BonusName.forEach(bonus => {
			let newBonus = this.bonusList.get(nextBonusData.Bonus as Bonus);
			if (!newBonus) throw "No such bonus!";
			this.currentBonus = newBonus;
			nextBonusData = null;
			currentindexData = null;
			//this.runingBonuses = bonusWon.reverse();

			//});
		}
	}

	

	public OnBonusTotalResult(totalResult: BonusTotalResult): void {
		// Log.Debug(this.logGroup, "OnBonusTotalResult(runResult: " + JSON.stringify(totalResult) + ")");
	}

	public OnBonusFinish(bonusFinish: BonusFinish): void {
		// Log.Debug(this.logGroup, "OnBonusFinish(bonusFinish: " + JSON.stringify(bonusFinish) + ")");
	}

	protected bet: SlotGameBet = null;

	//protected bonusStartConfig: IBonusStartConfig = null;
	protected simpleBonusSpin : FreegamesSpinAction [] = null; 
	protected simpleBonusConfig : FreegamesSpinAction = null;
	protected startAction : FreegamesStartAction = null;
	public Prepare(bonusStartConfig: IBonusStartConfig): void
	{

		
		this.startAction = (bonusStartConfig.actions as FreegamesStartAction []).find(b => b.Phase == "Start");
		this.simpleBonusConfig = (bonusStartConfig.actions as FreegamesSpinAction []).find(b => b.Phase == "Start");
		this.simpleBonusSpin = (bonusStartConfig.actions as FreegamesSpinAction []).filter(b => b.Bonus == "FreeGameBonus");
		this.bet = bonusStartConfig.bet;				
		this.spinIndexData = 0 ; 
		// this.scatterRandomAwardFeature?.UpdateReels({
		// 	playWindow: this.simpleBonusConfig.
		// 	reelSet: this.config.MultiReelSets[this.startAction.ReelSetId].map(reel => reel.Symbols)
		// });
		this.scatterRandomAwardFeature?.UpdateBet(bonusStartConfig.bet);
		this.scatterRandomAwardFeature?.Start();
		this.simpleAllBonusSpinResult = bonusStartConfig.actions;
		// Log.Debug(this.logGroup, "Prepare() config: ", this.simpleBonusConfig);
		console.log("ApiResultFG:",this.simpleBonusSpin);
		this.symbolsAnimation.Stop();
		//this.bonusTriggerAnimation.Stop();
		this.plusOneAnim.ResetCount();

		this.scatterRandomAwardFeature?.UpdateReels({
			playWindow: this.params.windowSymbolSize,
			reelSet: this.params.bonusConfiguration.ReelSet
		});
		//console.log("FG-StartAction:",this.simpleBonusSpin);
		this.totalSpins = this.startAction.SpinsStarted;
	}


	public HistoryView( actionIndex:number, gameState: SimpleSlotGameState): HTMLElement
	{
		//let gameState : SimpleSlotGameState = JSON.parse(entry2.HistoryGameState.GameState); 		

		let action: FreegamesSpinAction = gameState.Actions[actionIndex]as FreegamesSpinAction;
		let PayTableDivSize:Size =  new Size(20,17);
		
		
		let bonusView: HTMLElement = CreateElement("div",{ classes:["bonusView", "FreeGameHistory"],
				style:
				{
					//width:"100%",
					height: Scale.Hpx(975),
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					flexDirection: "column",
				}
		});
		
		// in first action we only get number of picked free games
		if (action.Phase == "Start") {
			CreateElement("div",{
			style: 
			{
				textAlign:"center",
				lineHeight: Scale.fhpx(50),
				fontSize: Scale.fhpx(50),
				width: "100%",
				height: "100%",
				color: "white",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			},
			innerHTML: `FREE GAME START, ${action.SpinsStarted} SPINS AWARDED!`, 
			parentToAppend: bonusView,			
		});

			// let gameView: HTMLElement = CreateElement("div", {
			// 	classes: ["gameBackground"], parentToAppend: bonusView,
			// 	style:
			// 	{
			// 		width: Scale.Wpx(900),
			// 		height: Scale.Hpx(700),
			// 		backgroundRepeat: "no-repeat",
			// 		backgroundSize: "cover",
			// 		backgroundPosition: "center",
			// 		display: "flex",
			// 		flexDirection: "row",
			// 		justifyContent: "center",
			// 		alignItems: "center",
			// 		fontSize: Scale.fhpx(100),
			// 		color: "white",
			// 		backgroundImage: this.gameBackground.CssBackground(),
			// 	}
			// });

			// let pickedFreeGames = CreateElement("div", {
			// 	classes: ["pickedFreeGames"], parentToAppend: gameView,
			// 	style:
			// 	{
			// 		width: Scale.Wpx(300),
			// 		height: Scale.Hpx(300),
			// 		display: "flex",
			// 		justifyContent: "center",
			// 		alignItems: "center",
			// 	}
			// });

			//let pickCanvas: MyCanvas = new MyCanvas(new Size(Scale.H(350), Scale.W(350)));
			// let pickSprite: CanvasSprite = this.canvasSprite;
			//pickCanvas.DrawImage(pickSprite.sprite.IdleFrame, pickSprite.sprite.IdleFrameRect, pickCanvas.rect)

			//pickedFreeGames.appendChild(pickCanvas.view);

			// let awarderFreeGames: HTMLElement = CreateElement("div", {
			// 	classes: ["awarderFreeGames"], parentToAppend: pickedFreeGames, innerHTML: "" + action.SpinsStarted,
			// 	style:
			// 	{
			// 		position: "absolute",
			// 		display: "flex",
			// 		justifyContent: "center",
			// 		alignItems: "center",
			// 		fontSize: Scale.fhpx(100),
			// 		color: "white",
			// 	}
			// });

			return bonusView;

		}
		else if (action.Phase == "Spin" ) {
			let lineWinsCount: number = action.Win.ResultLines.length;
			let lines: LineWin[] = action.Win.ResultLines;


			let reelView: HTMLElement = null;
			//reel view
			{
				let gameView: HTMLElement = CreateElement("div", {
					classes: ["gameBackground"], parentToAppend: bonusView,
					style:
					{
						width: Scale.Xpx(700),
						height: Scale.Hpx(700),
						backgroundRepeat: "no-repeat",
						backgroundSize: "cover",
						backgroundPosition: "center",
						display: "flex",
						flexDirection: "row",
						justifyContent: "center",
						alignItems: "center",
						backgroundImage: this.gameBackground,
					}
				});

				// reel view
				reelView = CreateElement("div", {
					classes: ["reelView"], parentToAppend: gameView,
					style:
					{
						width: Scale.Xpx(770),
						height: Scale.Hpx(490),
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}
				});
			}
			

			// all lines display
			{
				let linesAll: HTMLElement = CreateElement("div", {
					classes: ["linesAll", this.resid.Add("History").Scope()], parentToAppend: bonusView,
					style:
					{
						width: "100%",
						height: Scale.Hpx(975),
						display: "flex",
						flexDirection: "row",
						flexWrap: "wrap",
						justifyContent: "center",
					}
				});

				for (let i = 0; i < gameState.Bet.Bet.Lines; i++) {
					let line = CreateElement("div", {
						classes: ["line", "" + i], parentToAppend: linesAll,
						style:
						{
							width: Scale.Wpx(131),
							//marginBottom:Scale.XYpx(5),
							display: "flex",
							flexDirection: "column",
							justifyContent: "center",
							alignItems: "center",

						}
					});
					
					let currentWinLine = action.Win.ResultLines.find(a => a.LineIndex == i);
					let lineLayout: HTMLElement = CreateElement("div", {
						classes: ["lineLayout"], parentToAppend: line, innerHTML: this.params.slotGame.CreatePlayLines([this.params.slotGameInitData.Playlines[i]], Size.FromPlayWindow(this.params.windowSymbolSize), i, PayTableDivSize,false),
						style:
						{
							display: "flex",
							justifyContent: "center",
							width: Scale.Hpx(78.59),
							filter: currentWinLine ? "" : "brightness(50%)",
						}
					});					
					let pays : string = "&nbsp";
					if(currentWinLine)
					{
						pays = "" + currentWinLine.SymbolCount + "×" + currentWinLine.SymbolID + " pays " + service.moneyFormatter.FormatCurrency(currentWinLine.Win);
					}
					let lineStats = CreateElement("div", {
						classes: ["lineStats"], parentToAppend: line, innerHTML: pays,
						style:
						{
							fontSize: Scale.fhpx(12),
							color: "white",
							textAlign: "center",
							width: "100%",
							//display: "flex",
							//justifyContent: "flex-start",
							lineHeight: Scale.fhpx(10),
							margin: Scale.fhpx(3),
						}
					});
				
				}
			}

			let symbolSize = this.historySpinableReels.GetSymbolSize();

			console.log("ExpectedSymbols", action.SpinWithFeatures.ReelRowExpectedSymbols);

			for (let i = 0; i < action.SpinWithFeatures.ReelRowExpectedSymbols.length; i++) {
				for (let j = 0; j < action.SpinWithFeatures.ReelRowExpectedSymbols[i].length; j++) {



					let symbol = this.params.symbolCollection.symbolCollectionMap.get("Symbol_" + action.Spin.ExpectedSymbols[i][j]).imgResource.cloneNode() as HTMLElement;
					//if (this.historySpinableReels.symbolsContainer[i][j].childElementCount >=2) this.historySpinableReels.symbolsContainer[i][j].replaceChild(this.historySpinableReels.symbolsContainer[i][j].lastElementChild,symbol)
					//let symbolSize =  this.historySpinableReels.GetSymbolSize();
					symbol.style.width = symbolSize.Width + "px";
					symbol.style.height = "auto";
					symbol.style.position = "absolute";

					const reverseRowIndex = action.SpinWithFeatures.ReelRowExpectedSymbols[i].length - 1 - j;
					while (this.historySpinableReels.symbolsContainer[i][reverseRowIndex].firstChild) {
						this.historySpinableReels.symbolsContainer[i][reverseRowIndex].removeChild(this.historySpinableReels.symbolsContainer[i][reverseRowIndex].firstChild);
					}

					const symbolContainer = this.historySpinableReels.symbolsContainer[i][reverseRowIndex];

					symbolContainer.appendChild(symbol);
					//let canvas: MyCanvas = new MyCanvas(symbolSize);

					//let scatterRandomAwardResult: ScatterRandomAwardResult = (action.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult)

					//ADD SRA VALUE
					if (action.SpinWithFeatures.FeatureResults["ScatterRandomAward"])
					{
						const scatterPosition: AwardOptionPosition = (action.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult).ScattersPosition.find(s => i == s.Col && j == s.Row);
						
						if (scatterPosition != null) {
		
							const textHTML = CreateElement("div", {
								style: {
									fontSize: Scale.fhpx(20),
									textAlign: "center",
									justifyContent: "center",
									fontFamily: "NotoSansDisplay-Bold",
									alignContent: "center",
									zIndex: ZIndex.BonusWin + "",
									color: "white",
									textShadow: `${Scale.fhpx(1)} ${Scale.fhpx(1)}  ${Scale.fhpx(1)} black , ${Scale.fhpx(2)} ${Scale.fhpx(2)}  ${Scale.fhpx(2)} black  `
								}
							});
		
							this.scatterRandomAwardFeature?.GetHistoryValue({
								bet: gameState.Bet.Bet,
								scatterPosition: scatterPosition,
								parentElement: textHTML,
								multiplier: 1
							});
		
							symbolContainer.appendChild(textHTML);
						}
					}
				}

			}

			reelView.appendChild(this.historySpinableReels.GetView());


			return bonusView;
		}
		else if (action.Phase == "End") {

			let gameView: HTMLElement = CreateElement("div", {
				classes: ["gameBackground"], parentToAppend: bonusView,
				style:
				{
					width: Scale.Wpx(900),
					height: Scale.Hpx(700),
					backgroundRepeat: "no-repeat",
					backgroundSize: "cover",
					backgroundPosition: "center",
					display: "flex",
					flexDirection: "row",
					justifyContent: "center",
					alignItems: "center",
					fontSize: Scale.fhpx(100),
					color: "white",
					backgroundImage: this.gameBackground,
				}
			});

			let endAction = gameState.Actions[actionIndex] as FreegamesEndAction;
			gameView.style.flexDirection = "column";
			let titleBonusWin: HTMLElement = CreateElement("div", {
				classes: ["titleBonusWin"], parentToAppend: gameView,
				style:
				{
					width: "100%",
					height: Scale.Hpx(300),
					backgroundRepeat: "no-repeat",
					backgroundSize: "cover",
					backgroundPosition: "center",
					display: "flex",
					flexDirection: "row",
					justifyContent: "center",
					alignItems: "center",
					fontSize: Scale.fhpx(100),
					color: "white",
					textShadow: `${Scale.XY(10)}px ${Scale.XY(10)}px ${Scale.XY(10)}px black, 0px 0px ${Scale.XY(20)}px black, 0px 0px ${Scale.XY(30)}px black`,

				}
			});
			titleBonusWin.innerText = " Bonus Win";

			let winView: HTMLElement = CreateElement("div", {
				classes: ["winView"], parentToAppend: gameView,
				style:
				{
					width: "80%",
					height: Scale.Hpx(180),
					backgroundRepeat: "no-repeat",
					backgroundSize: "cover",
					backgroundPosition: "center",
					display: "flex",
					flexDirection: "row",
					justifyContent: "center",
					alignItems: "center",
					backgroundColor: "rgba(0,0,0,0.5)",
					fontSize: Scale.fhpx(100),
					color: "white",
					textShadow: `0px 0px ${Scale.XY(10)}px black, 0px 0px ${Scale.XY(20)}px black, 0px 0px ${Scale.XY(30)}px black`,
					borderWidth: Scale.XYpx(5),
					borderStyle: "solid",
					filter: `blur(${Scale.XYpx(2)})`,
					backgroundImage: "linear-gradient(rgb(0, 0, 0), rgb(22, 22, 206),rgb(0, 0, 0)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
				}
			});
			winView.innerText = service.moneyFormatter.FormatCurrency(endAction.WinSinceGameStart.TotalWin.InCents)



			return bonusView;
		}


		
		return null;
	}

	public HistoryStats2( actionIndex:number,  gameState : SimpleSlotGameState): ActionStats
	{
		let action: FreegamesSpinAction = gameState.Actions[actionIndex] as FreegamesSpinAction;
		
		// let actionStats: HTMLElement = CreateElement("div", {
		// 	style:
		// 	{
		// 		width:"100%",
		// 		height:"100%",
		// 	}
		// });
		
		if(action.Phase == "Start")
		{
			return {
				Bonus : action.Bonus, 
				Action : action.Action, 
				Stats : [{key: "Runs started", value: service.moneyFormatter.FormatQuantity(action.SpinsStarted)}]
			}	
			
			// let pickedFreeGames = CreateElement("div", {classes:["pickedFreeGames"], innerHTML: "Starting freeGames: " + action.NumFreegames, parentToAppend:actionStats });
			// return actionStats;
		}
		else if(action.Phase == "Spin")
		{
			// let lineWins: number = action.LineWins.length;
	
			// let runsPlayed = CreateElement("div", {classes:["runsPlayed"], innerHTML: "Runs Played: " + action.PlayedFreegames, parentToAppend:actionStats });
			// let runsRemaining = CreateElement("div", {classes:["runsRemaining"], innerHTML: "Runs Remaining: " + action.RemainingFreegames, parentToAppend:actionStats });
			// let gameLineWins = CreateElement("div", {classes:["gameLineWins"], innerHTML:"# Wining lines: "+ lineWins , parentToAppend:actionStats });
			// let runWin = CreateElement("div", {classes:["runWin"], innerHTML:"Current run win: "+ this.moneyFormatter.FormatCurrency(action.RunWin.InCents), parentToAppend:actionStats });
			// let winUpToNow = CreateElement("div", {classes:["winUpToNow"], innerHTML:"Total bonus win: "+ this.moneyFormatter.FormatCurrency(action.WinUpToNow.InCents), parentToAppend:actionStats });
			// let BonusTriggered = CreateElement("div",{classes:["bonusTriggered"], innerHTML:"Bonus: "+ action.TriggeredBonus, parentToAppend:actionStats});

			return {		
				Bonus : action.Bonus,
				Action : action.Action,
				Stats : [
				{key: "Runs started", value: service.moneyFormatter.FormatQuantity(action.SpinsStarted)},
				{key: "Runs played", value: service.moneyFormatter.FormatQuantity(action.SpinsPlayed)},
				{key: "Runs remaining", value: service.moneyFormatter.FormatQuantity(action.SpinsRemaining)},
				{key: "Current run win", value: service.moneyFormatter.FormatCurrency(action.WinAmounts.TotalWin.InCents)},
				{key: "Total bonus win", value: service.moneyFormatter.FormatCurrency(action.WinSinceGameStart.TotalWin.InCents)},
				]
			}
		}
		else if (action.Phase == "End"){
			let actionEnd: FreegamesEndAction = gameState.Actions[actionIndex] as FreegamesEndAction;
			return {
				Bonus : action.Bonus,
				Action : action.Action,		
				Stats : [
				{key: "Bonus Win", value: service.moneyFormatter.FormatCurrency(action.WinSinceBonusStart.TotalWin.InCents)},
				{key: "Total Win", value: service.moneyFormatter.FormatCurrency(action.WinSinceGameStart.TotalWin.InCents)},
				]
			}
		}
		
		return null;
	}

	// public PixiCanvasCrash(): void {
	// 	console.log("PIXI destroyed FreeGames:", this.gameName);
	// 	this.spinnableReels.ForceContextCrash();
	// }

	public ReelsRestored() {
		this.reelElement = this.spinnableReels.ReelElements;
		this.reelMask = this.spinnableReels.ReelWindowMask;
		this.RedrawAllReels();
	}

	protected RedrawAllReels() {

		for (let i = 0; i < this.spinnableReels.GetWindowSymbolSize().Width; i++) {
			this.RedrawReel(i);
		}
	}

	// public DestroyPixi() {
	// 	this.spinnableReels.Destroy();
	// 	//console.log("PIXI destroyed FreeGames:", this.gameName);
	// }

	public ReCreatePixiReels() {
		
		console.log("PIXI start recreated FreeGameBonus:", this.gameName);
	}
//app from base game 
	protected gameViewApp : PIXI.Container = null;
	protected containerBonusViewApp : PIXI.Container = null;
	protected Created: boolean = false;
	public async GameSelected(app : PIXI.Container)
	{		
		this.gameViewApp = app;
		//create reels or filling pot 
		if (Settings.fillingPotFeature == FillingPotFeature.Disable){
			this.spinnableReels.Create(this.gameViewApp, null);
		}
		if (Settings.fillingPotFeature == FillingPotFeature.Enable){
			await this.fillingPotFeature?.Create(globalThis?.gameViewAppPixiResponsive?.GetAppView());
			this.shakeAnimation.CreateShakeAnimationPixi(this.fillingPotFeature?.GetReelContainer());
		}
		//create view main bonus 
		this.containerBonusViewApp = new PIXI.Container();				
		this.containerBonusViewApp.name = "containerBonusViewApp"+this.bonusName;
		this.containerBonusViewApp.width = Settings.ScreenWidth;
		this.containerBonusViewApp.height = Settings.ScreenHeight * Settings.Screens;
		this.gameViewApp.addChild(this.containerBonusViewApp);		
		this.CreateContainersPIXIAPPScreen1();
		//create info stats for 2screens 
		this.CreateContainersPIXIAPPScreen2();

	
		// let texture = new PIXI.Sprite(PIXI.Texture.WHITE);
		// texture.name = "plus-One-Position"
		// texture.width = this.bonusGameInfoStatsPIXIAPP.width;
		// texture.height = this.bonusGameInfoStatsPIXIAPP.height;
		// texture.position.set(this.bonusGameInfoStatsPIXIAPP.getGlobalPosition().x,this.bonusGameInfoStatsPIXIAPP.getGlobalPosition().y);
		// this.gameViewApp.stage.addChild(texture);	


		//add plusone view pixi app
		this.containerBonusViewApp.addChild(this.plusOneAnim.CreatePIXAPP());
		//create Wild feature
		this.CreateFeatures();

		this.bigWinCountAnimation.CreatePIXIAPP();
		this.containerBonusViewApp.addChild(this.bigWinCountAnimation.ViewPIXIAPP());

		//winMessageAnimation Create PIXI
		this.winMessageAnimation.CreatePIXIAPP();
		this.containerBonusViewApp.addChild(this.winMessageAnimation.ViewPIXIAPP());

		if(this.jackpotSharedShow != null){
			this.jackpotSharedShow?.Create();
			this.containerBonusViewApp?.addChild(this.jackpotSharedShow?.View());			
		}		
	}

	protected introMessageContainerPIXIAPP: PIXI.Container = null;
	protected finalMessageContainerPIXIAPP: PIXI.Container = null;	
	protected messageContainerPIXIAPP: PIXI.Container = null;	
	//protected startValueSpinsText : Map<string,PIXI.Text> = new Map<string,PIXI.Text>();
	//protected spinRemainingTextPIXIAPP : PIXI.Text = null;
	protected bonusGameInfoStatsPIXIAPP: PIXI.Container = null;
	//protected bonunsGameAwardViewPIXIAPP: PIXI.Container = null;
	//spine	
	//protected spineSpinsRemaining: Spine = null;	
	//protespineSpinsPlayed: Spine = null;	
	
	
	//skipMessageContainer 
	//protected skipCometMessageContainer : PIXI.Container = null;
	protected CreateContainersPIXIAPPScreen1(){
		//fix stops spinnable reels 
		if (Settings.touchToStop == true) {

			this.gameViewApp.addEventListener('mousedown', (e) => {
				this.spinAnimation.RequestStop();
			});
		}		

		this.anticipationAnimation?.Create(this.spinnableReels.GetReelBackgroundRect() , this.params.windowRectangle);			
		this.containerBonusViewApp?.addChild(this.anticipationAnimation?.GetView());

		this.messageContainerPIXIAPP  = new PIXI.Container()
		this.messageContainerPIXIAPP.width = Scale.W(1920);
		this.messageContainerPIXIAPP.height = Scale.H(1080);
		this.messageContainerPIXIAPP.x =  0
		this.messageContainerPIXIAPP.y =  Settings.ScreenHeight * (Settings.Screens-1);
		this.messageContainerPIXIAPP.name = "messageContainerApp";
		this.containerBonusViewApp.addChild(this.messageContainerPIXIAPP);

		this.introMessageContainerPIXIAPP = new PIXI.Container();
		this.introMessageContainerPIXIAPP.width = Scale.W(1152);
		this.introMessageContainerPIXIAPP.height = Scale.H(648);
		this.introMessageContainerPIXIAPP.pivot.set(Scale.W(1152) / 2, Scale.H(648) / 2)
		this.introMessageContainerPIXIAPP.x = (Scale.W(1920) / 2) - (this.introMessageContainerPIXIAPP.width / 2)
		this.introMessageContainerPIXIAPP.y = (Scale.W(1080 / 2) - (this.introMessageContainerPIXIAPP.height / 2)) - Scale.Y(75);
		this.introMessageContainerPIXIAPP.name = "introMessageContainer";
		this.introMessageContainerPIXIAPP.visible = false;
		this.messageContainerPIXIAPP.addChild(this.introMessageContainerPIXIAPP);

		let spriteintroSpanishMessageContainerApp = PIXI.Sprite.from(this.textureDialogBonus);		
		spriteintroSpanishMessageContainerApp.width = Scale.W(1200),
		spriteintroSpanishMessageContainerApp.height = Scale.H(700);
		spriteintroSpanishMessageContainerApp.y = Scale.Y(-56.5)
		this.introMessageContainerPIXIAPP.addChild(spriteintroSpanishMessageContainerApp);


		let spriteintroTextureMessageContainerApp = PIXI.Sprite.from( (this.textureByLanguage[this.translator.t.languageEnglish.toLocaleLowerCase()] as TextureDialogLanguage).textureBonusIntro);		
		//spriteintroTextureMessageContainerApp.width = Scale.W(1052),
		//spriteintroTextureMessageContainerApp.height = Scale.H(548);
		spriteintroTextureMessageContainerApp.scale.set(Scale.H(1),Scale.W(1));
		spriteintroTextureMessageContainerApp.anchor.set(0.5,0.5);
		spriteintroTextureMessageContainerApp.x =  Scale.W(1152) / 2
		spriteintroTextureMessageContainerApp.y = (Scale.H(648) / 2) - Scale.W(80);
		this.introMessageContainerPIXIAPP.addChild(spriteintroTextureMessageContainerApp);

		
		

		let buttonIntroContainerApp: PIXI.Container = new PIXI.Container()
		buttonIntroContainerApp.name="buttonIntroContainerApp"
		buttonIntroContainerApp.width = Scale.W(600);
		buttonIntroContainerApp.height = Scale.H(300);
		buttonIntroContainerApp.y = Scale.H(600);
		buttonIntroContainerApp.x = Scale.H(1152) / 2 ;
		buttonIntroContainerApp.pivot.set(Scale.W(600)/2,Scale.H(300)/2);
		buttonIntroContainerApp.interactive = true;
		this.introMessageContainerPIXIAPP.addChild(buttonIntroContainerApp);

		let spritebuttonIntroContainerApp = PIXI.Sprite.from(this.textureButtonBonus);		
		spritebuttonIntroContainerApp.width = Scale.W(600),
		spritebuttonIntroContainerApp.height = Scale.H(300);
		buttonIntroContainerApp.addChild(spritebuttonIntroContainerApp);

		//create text style
		let textstyle = new PIXI.TextStyle({
            fontFamily: 'NotoSansDisplay-Bold',			
			fontSize: Scale.fh(100),
			//fontStyle: 'italic',
			fontWeight: 'bold',
			fill: ["#F2E416", "#F2BE22" , "#C2760E" , "#F2BE22", "#F2E416" ], // gradient
			stroke: 'black',
			strokeThickness: Scale.fh(10),			
			wordWrap: true,
			wordWrapWidth: Scale.fh(300),
			lineJoin: 'round',
			textBaseline : "middle",			
        });
        //this.app.renderer.view.style.position = 'fixed';
       let startTextView = new PIXI.Text(this.translator.t.freegameStart, textstyle);
	   startTextView.anchor.set(0.5,0.5);
	   startTextView.x = (Scale.W(600) / 2);
	   startTextView.y = (Scale.W(300) / 2);	
	   startTextView.context.textBaseline = "alphabetic";   	   
	   buttonIntroContainerApp.addChild(startTextView);
        
		//spritebuttonIntroContainerApp.tint = 0xff0000;		
		buttonIntroContainerApp.addListener("pointerdown", (ev: MouseEvent) => {
			if (this.stateMachine.State() == FreegameStates.NoPickIntro) {
				// Log.Debug(this.logGroup, "Intro message confirmed");
				this.stateMachine.ChangeState(FreegameStates.WaitFirstSpin);
			}
			else {
				Log.Error(this.logGroup, "Can't confirm intro message, current state: " + FreegameStates[this.stateMachine.State()] + ", required state: " + FreegameStates[FreegameStates.IntroMessage]);
			}
		});

		//Create Final MessageContainer
		this.finalMessageContainerPIXIAPP = new PIXI.Container();
		this.finalMessageContainerPIXIAPP.width = Scale.W(1152);
		this.finalMessageContainerPIXIAPP.height = Scale.H(648);
		this.finalMessageContainerPIXIAPP.pivot.set(Scale.W(1152) / 2, Scale.H(648) / 2)
		this.finalMessageContainerPIXIAPP.x = (Scale.W(1920) / 2) - (this.finalMessageContainerPIXIAPP.width / 2)
		this.finalMessageContainerPIXIAPP.y = (Scale.W(1080 / 2) - (this.finalMessageContainerPIXIAPP.height / 2)) - Scale.Y(75); 
		this.finalMessageContainerPIXIAPP.name = "finalMessageContainerApp";
		this.finalMessageContainerPIXIAPP.visible = false;
		this.finalMessageContainerPIXIAPP.interactiveChildren = true;	
		this.finalMessageContainerPIXIAPP.interactive = true;		
		this.messageContainerPIXIAPP.addChild(this.finalMessageContainerPIXIAPP);

		
		let spritefinalSpanishMessageContainerApp = PIXI.Sprite.from(this.textureDialogBonus);		
		spritefinalSpanishMessageContainerApp.width = Scale.W(1200),
		spritefinalSpanishMessageContainerApp.height = Scale.H(700);
		spritefinalSpanishMessageContainerApp.y = Scale.Y(-56.5)
		this.finalMessageContainerPIXIAPP.addChild(spritefinalSpanishMessageContainerApp);


		let spritefinalTextureMessageContainerApp = PIXI.Sprite.from( (this.textureByLanguage[this.translator.t.languageEnglish.toLocaleLowerCase()] as TextureDialogLanguage).textureBonusFinal);		
		//spritefinalTextureMessageContainerApp.width = Scale.W(1052),
		//spritefinalTextureMessageContainerApp.height = Scale.H(548);
		spritefinalTextureMessageContainerApp.scale.set(Scale.H(1),Scale.W(1));
		spritefinalTextureMessageContainerApp.anchor.set(0.5,0.5);
		spritefinalTextureMessageContainerApp.x =  Scale.W(1152) / 2
		spritefinalTextureMessageContainerApp.y = (Scale.H(648) / 2) - Scale.W(80);
		this.finalMessageContainerPIXIAPP.addChild(spritefinalTextureMessageContainerApp);

		

		let finalbuttonIntroContainerApp: PIXI.Container = new PIXI.Container()
		finalbuttonIntroContainerApp.name="finalbuttonIntroContainerApp"
		finalbuttonIntroContainerApp.width = Scale.W(600);
		finalbuttonIntroContainerApp.height = Scale.H(300);
		finalbuttonIntroContainerApp.y = Scale.H(600);
		finalbuttonIntroContainerApp.x = Scale.H(1152) / 2 ;
		finalbuttonIntroContainerApp.pivot.set(Scale.W(600)/2,Scale.H(300)/2);
		finalbuttonIntroContainerApp.interactive = true;
		finalbuttonIntroContainerApp.interactiveChildren = true;
		
		this.finalMessageContainerPIXIAPP.addChild(finalbuttonIntroContainerApp);

		let spritebuttonFinalContainerApp = PIXI.Sprite.from(this.textureButtonBonus);		
		spritebuttonFinalContainerApp.width = Scale.W(600),
		spritebuttonFinalContainerApp.height = Scale.H(300);
		//spritebuttonFinalContainerApp.tint = 0xff0000;
		finalbuttonIntroContainerApp.addChild(spritebuttonFinalContainerApp);	

		let finalTextView = new PIXI.Text(this.translator.t.freegameExit, textstyle);
		finalTextView.x = (Scale.W(600) / 2);
		finalTextView.y = (Scale.W(300) / 2);
		finalTextView.anchor.set(0.5,0.5),
		finalTextView.context.textBaseline = "alphabetic";
		finalbuttonIntroContainerApp.addChild(finalTextView);

		finalbuttonIntroContainerApp.addListener("pointerdown", (ev: MouseEvent) => {			
			if (this.stateMachine.State() == FreegameStates.FinalMessage) {		
				//this.CreateTransitionPixi();		
				//SHOW VIDEO TRANSITION				
				this.Spin();
			}
			else {
				Log.Error(this.logGroup, "Can't confirm intro message, current state: " + FreegameStates[this.stateMachine.State()] + ", required state: " + FreegameStates[FreegameStates.IntroMessage]);
			}
		});
		

		
		this.translator.SetOnLanguageChangedCallback(() => {				
			spriteintroTextureMessageContainerApp.texture = (this.textureByLanguage[this.translator.t.languageEnglish.toLocaleLowerCase()] as TextureDialogLanguage).textureBonusIntro;
			spritefinalTextureMessageContainerApp.texture = (this.textureByLanguage[this.translator.t.languageEnglish.toLocaleLowerCase()] as TextureDialogLanguage).textureBonusFinal;	
			startTextView.text = this.translator.t.freegameStart;
			finalTextView.text = this.translator.t.freegameExit;
			//skipMessageCommets.text = this.translator.t.skipMessageCommets;
		});	
		// this.skipMessageHide = this.systemContext.TimingContext().CreateTimeout("skipMessageHideShowTime", 1500, () => {
		// 	this.skipCometMessageContainer.visible = false;			
		// });

		//append winlines pixi app 
		//this.containerBonusViewApp.addChild(this.winLinesAnimation.ViewPIXIAPP());
	}
	

	
	protected startArray : string[] = ["Left","Right"] ;

	protected CreateContainersPIXIAPPScreen2() {

		let containerViewScreen2 = new PIXI.Container();
		//containerViewScreen2.width = Settings.ScreenWidth;
		//containerViewScreen2.height = Settings.ScreenHeight;
		containerViewScreen2.y = Settings.ScreenHeight * (Settings.Screens -2);
		containerViewScreen2.name = "containerViewScreen2PIXIAPP";
		if (Settings.Screens == 2 || Settings.Enable2plus1 == true) {
			containerViewScreen2.scale.set(0.6);
			//containerViewScreen2.position.set(Scale.X(-135), Scale.Y(481));
		}
		this.containerBonusViewApp.addChild(containerViewScreen2);

		this.bonusGameInfoStatsPIXIAPP = new PIXI.Container();
		this.bonusGameInfoStatsPIXIAPP.name = "bonusGameInfoStatsPIXIAPP";
		containerViewScreen2.addChild(this.bonusGameInfoStatsPIXIAPP);		
		this.bonusGameInfoStatsPIXIAPP.position.set(Scale.X(0),Scale.Y(0));
		if(Settings.Screens == 2) this.bonusGameInfoStatsPIXIAPP.position.set(Scale.X(0),Scale.Y(450));		
		this.CreateInfoStats(this.bonusGameInfoStatsPIXIAPP);
		this.CreateAwarViewPIXIAPP(containerViewScreen2);
		
	}

	protected spinsStats : PIXI.Text = null;
	protected totalSpins : number = 0 ;

	//protected plusOneDestination: PIXI.Point = null;

	protected spineFrame: Spine = null;
	protected CreateInfoStats(container : PIXI.Container){
		
		//create spine frame 
		let spineFrame = CreateSpineResources(this.jsonSpinsRemainingSpine);
		this.spineFrame = spineFrame;
		container.addChild(spineFrame);
		spineFrame.name = "FrameSpinsRemaining";
		spineFrame.pivot.set(spineFrame.width/2 , spineFrame.height/2);
		spineFrame?.state.setAnimation(0,"anim",true);
		spineFrame.position.set(Scale.X(288), Scale.Y(94));
		//only use if you are win double bonus 
		//create Win Text SRA
		this.spinsStats = new PIXI.Text(this.translator.t.bonusSpinsRemainingAndTotal(this.session.played,this.totalSpins),{
            fontFamily: 'NotoSansDisplay-Bold',			
			fontSize: 50,			
			fontWeight: 'bold',
			fill: ["#F20505", "#F20505", "#F20505", "#F20505", "#F20505"], // gradient
			stroke: 'white',
			strokeThickness: 10,
			dropShadow : true,
			dropShadowColor : "#000000",
			dropShadowDistance : 5,
			dropShadowAngle : 0.52,	
			dropShadowAlpha : 1,		
			//wordWrap: true,			
			lineJoin: 'round',
			//textBaseline : "middle",			
        });
		this.spinsStats.anchor.set(0.5,0.5);	
		this.spinsStats.scale.y = -1;
		//this.spinsStats.position.set(Scale.X(1644), 0 );

		//add text into spine
		const containerValue = spineFrame.children.find((child) => child.name == "containerValue") as PIXI.Container;
		assertNotNullish(containerValue, "PlusOneAnimation: containerValue not found in spineFrame");
		containerValue.addChild(this.spinsStats);
		
		this.translator.SetOnLanguageChangedCallback(() => {
			this.spinsStats.text = this.translator.t.bonusSpinsRemainingAndTotal(this.session.played,this.totalSpins)
		});


		this.CreatePlusOneTarget();
	}

	protected CreatePlusOneTarget()
	{

		console.log("SpineFrame position:",this.spineFrame.position);
		console.log("SpineFrame scale:",this.spineFrame.scale);
		console.log("SpineFrame pivot:",this.spineFrame.pivot);
		console.log("SpineFrame global position:",this.spineFrame.getGlobalPosition());

		globalThis.spineFrame = this.spineFrame;


		
		const centerStarts: PIXI.IPointData = {
			x: this.spineFrame.getGlobalPosition().x,
			y: this.spineFrame.getGlobalPosition().y 
		}
		this.plusOneTarget = new PIXI.Point(centerStarts.x,centerStarts.y);
	}

	protected spineWinAward: Spine = null
	protected spineBonusTitleAward: Spine = null
	protected containerValueWinAwardText : PIXI.Text = null;
	protected bonusGameAwardViewPIXIAPP: PIXI.Container = null;
	//spine
	protected spineBonusTitle: Spine = null;
	//protected spineWinCountContainer: Spine = null;	
	//protected spineSpinsRemaining: Spine = null;	
	protected CreateAwarViewPIXIAPP(view : PIXI.Container){
		this.bonusGameAwardViewPIXIAPP = new PIXI.Container();
		this.bonusGameAwardViewPIXIAPP.name = "bonusGameAwardViewPIXIAPP";
		this.bonusGameAwardViewPIXIAPP.position.set(Settings.ScreenWidth,0);
		view.addChild(this.bonusGameAwardViewPIXIAPP);
		

		//create container and spine bonus title 
		let bonusWinAwardTitle = new PIXI.Container();				
		bonusWinAwardTitle.name = "bonusWinAwardTitle";				
		this.bonusGameAwardViewPIXIAPP.addChild(bonusWinAwardTitle);
		this.spineBonusTitleAward = CreateSpineResources(this.jsonBonusWinTitleSpine);
		//this.spineBonusTitleAward.scale.set(Scale.XY(1));		
		this.spineBonusTitleAward.state.timeScale = 1.5;		
		bonusWinAwardTitle.x = Scale.X(78);
		bonusWinAwardTitle.y =  Scale.Y(199); 
		bonusWinAwardTitle.addChild(this.spineBonusTitleAward);


		
		//create container and spine bonus title 
		let bonusWinAwardContainer = new PIXI.Container();
		bonusWinAwardContainer.name = "bonusWinAwardContainer";
		this.bonusGameAwardViewPIXIAPP.addChild(bonusWinAwardContainer);
		this.spineWinAward = CreateSpineResources(this.jsonWinAwardBonusSpine);
		this.spineWinAward.state.timeScale = 1.5
		//bonusWinAwardContainer.x = Settings.ScreenWidth / 2;
		bonusWinAwardContainer.y = Settings.ScreenHeight / 2;
		bonusWinAwardContainer.addChild(this.spineWinAward);

		console.log("Spine:",this.spineWinAward);



		//create container 
		let containerValue = new PIXI.Container();
		containerValue.name = "containerValue";
		//containerValue.pivot.set(this.positionSpinnableReelsSpinePivotContainer.width, this.positionSpinnableReelsSpinePivotContainer.height);
		containerValue.scale.set(1, -1);
		containerValue.position.y = (Settings.ScreenHeight * (Settings.Screens - 1)) * -1;


		//add container to spine
		let containerchildrensSpine = this.spineWinAward.children as PIXI.Container[];
		containerchildrensSpine.forEach((container) => {
			if (container.name == "containerValue") {
				//create Win Text SRA
				this.containerValueWinAwardText = new PIXI.Text("?", {
					fontFamily: 'NotoSansDisplay-Bold',
					fontSize: 230,
					fontWeight: 'bold',
					fill: ["#F2E416", "#F2BE22", "#C2760E", "#F2BE22", "#F2E416"], // gradient
					stroke: 'black',
					strokeThickness: 10,
					//wordWrap: true,			
					lineJoin: 'round',
					//textBaseline : "middle",			
				});
				this.containerValueWinAwardText.scale.set(1,-1);
				this.containerValueWinAwardText.anchor.set(0.5, 0.5);
				container.addChild(this.containerValueWinAwardText)
			}
		});

		containerchildrensSpine = null;
		

		//create Win Text SRA
		let containerValueWinAward = new PIXI.Text("?", {
            fontFamily: 'NotoSansDisplay-Bold',			
			fontSize: 120,			
			fontWeight: 'bold',
			fill: ["#F2E416", "#F2BE22" , "#C2760E" , "#F2BE22", "#F2E416" ], // gradient
			stroke: 'black',
			strokeThickness: 10,			
			//wordWrap: true,			
			lineJoin: 'round',
			//textBaseline : "middle",			
        });
		containerValueWinAward.anchor.set(0.5,0.5);
		containerValue.addChild(containerValueWinAward)

	
		if (Settings.Screens == 2 || Settings.Enable2plus1 == true) {
			this.bonusGameAwardViewPIXIAPP.position.set(Scale.X(3732), Scale.Y(830.5));
		}
	}

	protected CreateFeatures(){
		// // EXPANDING WILD
		for (let [name, feature] of this.features) {
			//await feature.ResourcesLoaded(resourceManager);
			
			if (feature){ 
				feature.CreatePIXIAPP();
				this.containerBonusViewApp.addChild(feature.ViewPIXIAPP());
			}				
		};

		this.SetupWinLines();
		// if (Settings.Screens == 2) {
		// 	this.plusOneTarget.x = Scale.X(291);
		// 	this.plusOneTarget.y = Scale.Y(894);
		// }
		// else if (Settings.Enable2plus1 == true) {
		// 	this.plusOneTarget.x = Scale.X(291);
		// 	this.plusOneTarget.y = Scale.Y(1974)
		// }
	}

	protected SetupWinLines() {
		let containerReels : PIXI.Container = null;
		if (this.params.gameConfig.winLinesDrawOrder == WinLinesDrawOrder.backSymbols) containerReels = this.fillingPotFeature?.GetReelContainer();
		this.winLinesAnimation.CreatePIXIAPP(containerReels);
		this.containerBonusViewApp?.addChild(this.winLinesAnimation.ViewPIXIAPP());
	}

	public GameExit() {		
		if (Settings.fillingPotFeature == FillingPotFeature.Enable) {
			Safe(() => {this.fillingPotFeature?.Destroy(); });
		} else {
			Safe(() => { this.spinnableReels.Destroy("Destroy FreegameBonusPIXIAPP") });
		}

		//clean data spine and pixi.app		
		Safe(() => { this.containerBonusViewApp.removeChildren(0, this.containerBonusViewApp.children.length - 1) });
		Safe(() => { this.introMessageContainerPIXIAPP.destroy({children: true, texture: false, baseTexture: true}) });
		Safe(() => { this.finalMessageContainerPIXIAPP.destroy({children: true, texture: false, baseTexture: true}) });
		Safe(() => { this.messageContainerPIXIAPP.destroy({children: true, texture: false, baseTexture: true}) });
		Safe(() => { this.bonusGameInfoStatsPIXIAPP.destroy({children: true, texture: false, baseTexture: true}) });
		Safe(() => { this.containerBonusViewApp.removeFromParent() });
		Safe(() => { this.plusOneAnim.ViewPIXIAPP().destroy({children: true, texture: false, baseTexture: true})});
		Safe(() => { this.bigWinCountAnimation.ViewPIXIAPP().destroy({children: true, texture: false, baseTexture: true})});
		Safe(() => {this.winMessageAnimation.ViewPIXIAPP().destroy({children : true})});

		Safe(() => { this.jackpotSharedShow?.Destroy(); });	
		Safe(() => { this.anticipationAnimation?.Destroy(); })
	}

	public override SharedJackpotWin(win: SharedJackpotWin) {		
		this.jackpotSharedShow?.ShowShared(win);		
	}

	public override UpdateSpinSpeed(changeSpeedParams: ChangeSpeedParams) {
		this.reelSpinAnimation.forEach(animation => {
			animation.UpdateSpinSpeed(changeSpeedParams.SpinParams)
		});
		this.winLinesAnimFactor = changeSpeedParams.CelebrationFactor
	}

	protected GetCelebrationType(): CelebrationType
	{
		let backendSettingsStringEnabled = this.params.backendSettings as unknown as BackendSettings;

		if(backendSettingsStringEnabled.GetString('play.celebration','celebration') == CelebrationType.Fast)
		{
			return CelebrationType.Fast;
		}
		
		if(backendSettingsStringEnabled.GetString('play.celebration','celebration') == CelebrationType.Normal)
		{
			return CelebrationType.Normal;
		}

		return CelebrationType.Slow;
	}
}
